import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      // Nav
      home: 'Suche',
      deals: 'Beste Deals',
      newest: 'Neueste',
      saved: 'Gespeichert',
      auctions: 'Auktionen',
      login: 'Anmelden',
      signupOrLogin: 'Registrieren / Anmelden',
      logout: 'Abmelden',
      proActiveMenu: 'Pro aktiv',
      proUpgradeMenu: 'Auf Pro wechseln',

      // Hero
      heroTitle: 'Finde die besten Angebote\nin der Schweiz',
      heroSubtitle: 'ScanMarket ist ein Aggregator, mit dem du gleichzeitig auf Ricardo, Tutti, Anibis, Shpock und eBay Schweiz suchen kannst.',
      heroTagline: 'Finde das Schnäppchen vor allen anderen.',
      liveUpdateBadge: 'Live · Inserate aktualisiert in Echtzeit',
      headerLiveText: 'aktualisiert',
      heroSearchBtn: 'Suchen',
      // Stats
      listingsCount: 'Inserate',
      apiDownMsg: 'Der Dienst ist momentan nicht erreichbar. Wir arbeiten daran — bitte in einem Moment erneut versuchen.',
      apiDownRetry: 'Erneut versuchen',
      similarResultsTitle: 'Ähnliche Inserate',
      similarResultsHint: 'ohne Elektro-Angabe, für «{q}»',
      correctedNoticePrefix: 'Ergebnisse für',
      correctedNoticeSuffix: 'stattdessen suchen nach',
      imageSearchTitle: 'Mit Foto suchen',
      imageSearchAnalyzing: 'Foto wird analysiert…',
      imageSearchFound: 'Erkannt',
      imageSearchNotRecognized: 'Objekt nicht erkannt — versuche ein anderes Foto',
      imageSearchFormatError: 'Nur JPG, PNG oder WEBP',
      imageSearchTooLarge: 'Foto zu gross (max. 6 MB)',
      imageSearchError: 'Fotosuche fehlgeschlagen',
      photoSearchCardTitle: 'Mit einem Foto suchen',
      photoSearchCardDesc: 'Foto aufnehmen oder hochladen — wir finden das Objekt auf allen Marktplätzen.',
      photoSearchCardCta: 'Foto wählen',
      photoSearchCardBadge: 'Neu',
      copyFilterLink: 'Link kopieren',
      photoSearchLoginRequired: 'Melde dich an, um mit einem Foto zu suchen',
      shareOnWhatsapp: 'Auf WhatsApp teilen',
      shareOnTelegram: 'Auf Telegram teilen',
      cl_priceArchive_title: 'Marktpreis mit Zeitfenster je Kategorie',
      cl_priceArchive_desc: 'Der Rabatt der Top-Deals wird jetzt auch mit bereits verkauften oder abgelaufenen Inseraten verglichen, mit einem Zeitfenster je Kategorie: 90 Tage für Elektronik, bis 6 Monate für Fahrzeuge, bis 12 Monate für Musikinstrumente, Werkzeuge und Uhren, bei Velos und saisonalen Sportartikeln die gleiche Saison des Vorjahres. Das Fenster wird nur erweitert, wenn es weniger als 20 ähnliche Inserate gibt, und dann siehst du es im Inserat.',
      cl_specSearch_title: 'Präzisere Suche nach Maßen und Objektiven',
      cl_specSearch_desc: '«Sony 12 - 24mm», «12–24 mm» oder «f2.8» werden jetzt gleich verstanden wie «12-24mm» und «F/2,8»: Du findest das Objektiv, egal wie es geschrieben ist. Und die Suche bleibt auch bei seltenen Anfragen schnell.',
      cl_dealsFast_title: 'Schnellere und sauberere Top-Deals',
      cl_dealsFast_desc: 'Die Top-Deals öffnen sich jetzt viel schneller und zeigen keine Immobilien, Tiere oder gebrauchten Schuhe mehr: nur Gegenstände, die man wirklich mit dem Marktpreis vergleichen kann.',
      cl_noReload_title: 'Kein Neuladen mehr beim Zurückkehren',
      cl_noReload_desc: 'Öffnest du während einer laufenden Suche ein Inserat auf der Originalseite und kehrst zurück, lädt die Seite nicht mehr neu und die Suche startet nicht von vorne: Sie läuft einfach weiter.',
      cl_gallery_title: "Fotos im Vollbild, wie in einer App",
      cl_gallery_desc: "Tippe auf das Foto eines Inserats: Wische zwischen den Bildern, zoome mit zwei Fingern oder Doppeltipp und wische nach unten zum Schliessen. Unten siehst du alle Miniaturen.",
      cl_back_title: "«Zurück» führt zu den Ergebnissen",
      cl_back_desc: "Auf dem Handy (Zurück-Taste oder Wischen auf dem iPhone) kommst du von einem Inserat jetzt zurück zu den Ergebnissen statt zur Startseite.",
      cl_centerView_title: "Inserat in der Bildschirmmitte",
      cl_centerView_desc: "Am Computer öffnet sich ein Inserat jetzt mittig in einem grösseren Fenster statt rechts am Rand.",
      cl_autoScroll_title: "Mehr Inserate automatisch",
      cl_autoScroll_desc: "Am Seitenende laden neue Inserate von selbst – kein «Weitere laden»-Knopf mehr.",
      cl_typoCategory_title: "Tippfehler: richtige Kategorie",
      cl_typoCategory_desc: "Schreibst du «ipune» oder «mercedesschwarz», korrigieren wir das Wort und setzen die Kategorie des richtigen Worts (Smartphone, Auto…). Und die Suche ist schneller.",
      cl_yearSearch_title: "Suche mit Jahrgang",
      cl_yearSearch_desc: "«iMac 2019» oder «Golf 2015» finden jetzt auch Titel mit Wörtern dazwischen, z. B. «iMac 27\" Retina 5K 2019».",
      cl_auctionReminder_title: "Erinnerung 1 Stunde vor Auktionsende (Pro)",
      cl_auctionReminder_desc: "Tippe bei einer Auktion auf ⏰ oder speichere sie: ca. 1 Stunde vor Ende bekommst du eine Nachricht auf Telegram und/oder per E-Mail – mit Foto, aktuellem Gebot und Sofortkauf-Preis. Den Kanal wählst du unter Gespeichert.",
      cl_ricardoPrices_title: "Ricardo-Auktionen: Preise korrigiert",
      cl_ricardoPrices_desc: "Bei manchen Ricardo-Auktionen wurde der Preis eines ähnlichen Inserats angezeigt. Jetzt lesen wir aktuelles Gebot und Sofortkauf nur noch aus der Auktion selbst.",
      cl_shareOne_title: "Ein einziger «Teilen»-Knopf",
      cl_shareOne_desc: "WhatsApp, Telegram und Link kopieren sind jetzt in einem Knopf «Teilen» – mehr Platz über den Ergebnissen.",
      cl_compactResults_title: "Kompaktere Ergebnisse auf dem Handy",
      cl_compactResults_desc: "Weniger Platz vor dem ersten Inserat: Kategorien und verwandte Suchen in einer Zeile, alle Knöpfe in einer Reihe, und die obere Leiste wird auf grossen Bildschirmen nicht mehr abgeschnitten.",
      shareSearch: 'Teilen',
      shareMoreApps: 'Andere Apps…',
      medianShort: 'Median',
      cl_photoWidget_title: 'Fotosuche direkt auf der Startseite',
      cl_photoWidget_desc: 'Der neue Bereich unter der Suchleiste: Foto aufnehmen oder hineinziehen und sofort passende Inserate sehen.',
      cl_newPricing_title: 'Neue Pro-Pläne: monatlich oder jährlich',
      cl_newPricing_desc: 'Pro für CHF 9.90 pro Monat oder CHF 99 pro Jahr (zwei Monate gratis). Beim ersten Abo gibt es ein hervorgehobenes Inserat gratis. Wer schon abonniert war, behält seinen alten Preis.',
      cl_telegramOneTap_title: 'Telegram-Alerts mit einem Tipp',
      cl_telegramOneTap_desc: 'Kein Chat-ID mehr zum Kopieren: "Telegram verbinden" tippen, im Bot auf Start drücken — fertig. Du bekommst die 3 besten Inserate mit Foto plus eine Zusammenfassung der übrigen, ohne Chat-Flut. Pro-Funktion.',
      cl_alertPrice_title: 'Alerts mit Preisgrenze und deinen Filtern',
      cl_alertPreview_title: 'Vorschau beim Erstellen eines Alarms',
      cl_alertPreview_desc: 'Beim Erstellen eines Alarms siehst du sofort, wie viele Inserate heute passen und wie viele in den letzten 7 Tagen dazugekommen sind. Passt nichts, schlagen wir dir einfachere Wörter vor.',
      cl_tgVolume_title: "Telegram: du wählst, wie viele Deals",
      cl_tgVolume_desc: "Bei den Top-Deals auf Telegram wählst du jetzt Wenige (3 auf einmal), Viele (10) oder Alle. Was über dem Limit liegt, kommt als «+N weitere Deals» mit Link zur ganzen Liste — kein Deal geht verloren.",
      cl_tgDeals_title: "Top-Deals auf Telegram (Pro)",
      cl_tgDeals_desc: "Neue Schnäppchen direkt im Telegram-Chat: Foto, Preis, Rabatt und Knopf zum Verkäufer. Wähle Kategorien, Mindestrabatt und Höchstpreis unter «Meine Alerts».",
      cl_fastAlerts_title: "Alerts alle 10 Minuten",
      cl_fastAlerts_desc: "Pro-Alerts werden jetzt alle 10 Minuten geprüft und können alle 30 Minuten benachrichtigen. Suchen von Pro-Nutzern laden die Marktplätze alle 30 Minuten neu.",
      cl_carSpecs_title: "Autos: Jahrgang und Kilometer",
      cl_carSpecs_desc: "Auf den Auto- und Motorrad-Karten siehst du Jahrgang und Kilometerstand. Der Jahresfilter ignoriert jetzt Daten wie «letzter Service 2023».",
      cl_newOnTop_title: "Neue Inserate immer oben",
      cl_newOnTop_desc: "Bleibst du auf der Ergebnisseite, erscheinen neue Inserate oben mit dem Hinweis «neue Inserate» — nie mehr unten in der Liste.",
      cl_autocomplete_title: 'Vorschläge beim Tippen',
      cl_autocomplete_desc: 'Schon beim Tippen zeigen wir dir die beliebtesten Suchen und deine letzten Suchen – mit der passenden Kategorie daneben (z. B. „iphone 13 in Smartphones“). Tippst du ins leere Feld, siehst du, was gerade im Trend ist.',
      cl_instantSearch_title: 'Blitzschnelle Suche',
      cl_instantSearch_desc: 'Suchergebnisse erscheinen jetzt praktisch sofort – auch bei Wörtern mit Synonymen („Sofa“, „Velo“) und bei Suchen aus zwei Wörtern. Und wenn viele Leute gleichzeitig suchen, bleibt die Seite trotzdem flüssig.',
      cl_newListingsPill_title: 'Neue Inserate ohne Unterbruch',
      cl_newListingsPill_desc: 'Während Vulpi im Hintergrund die Marktplätze nach neuen Inseraten durchsucht, bleibt deine Liste stehen. Findet er etwas, erscheint oben „X neue Inserate“: ein Tipp genügt und sie werden hervorgehoben angezeigt.',
      cl_alertSuggest_title: 'Tipp für zusammengeschriebene Wörter',
      cl_alertSuggest_desc: 'Schreibst du «iPhone 12mini» oder «golf7», schlagen wir dir mit einem Tipp die richtige Version vor («12 mini», «golf 7»), damit dir keine Inserate entgehen.',
      cl_smartSearch_title: 'Tolerantere Suche',
      cl_smartSearch_desc: 'Die Suche versteht jetzt auch zusammengeschriebene Wörter: «golf7» liefert dieselben Ergebnisse wie «golf 7». Und «Apple iPhone» findet auch Inserate, in denen nur «iPhone» steht.',
      cl_preciseAlerts_title: 'Präzisere Alarme',
      cl_preciseAlerts_desc: 'Alarme berücksichtigen nur noch ganze Wörter: Ein Alarm für «Kare» meldet keine «Schubkarre» mehr. Ausserdem erkennen Alarme wie «iPhone 12mini» jetzt auch Inserate mit «12 mini». Das gilt für alle bestehenden Alarme.',
      cl_vulpi_title: 'Darf ich vorstellen: Vulpi!',
      cl_vulpi_desc: 'ScanMarket hat ein Maskottchen: Vulpi, ein Fuchs, der Schnäppchen für dich erschnüffelt. Du triffst ihn auf der Seite, wenn eine Suche nichts findet, bei deinen gespeicherten Inseraten und Alarmen, auf der Pro-Seite und auf einer neuen Fehlerseite, wenn eine Adresse nicht existiert oder ein Inserat verkauft ist.',
      cl_newLogo_title: 'Neues Logo',
      cl_newLogo_desc: 'Das Logo ist jetzt Vulpis Kopf mit der roten Schweizer Lupe – gut sichtbar auch im Dunkelmodus. Der Fuchs ist auch das neue Symbol im Browser-Tab und auf dem Handy-Startbildschirm.',
      cl_vulpiAlerts_title: 'Alarme von Vulpi',
      cl_vulpiAlerts_desc: 'Alarm-E-Mails und Telegram-Nachrichten kommen jetzt von Vulpi: «Ich habe 3 neue Inserate für dich erschnüffelt!». Auch unser Telegram-Bot hat ein neues Profilbild.',
      cl_loginFox_title: 'Der Fuchs beim Anmelden',
      cl_loginFox_desc: 'Beim Anmelden und Registrieren folgt Vulpi deiner Maus mit den Augen, schaut dir beim Schreiben zu und hält sich die Augen zu, wenn du dein Passwort eingibst.',
      cl_smartBar_title: 'Suchleiste, die dir folgt',
      cl_smartBar_desc: 'Scrollst du nach unten, verschwindet die obere Leiste und lässt mehr Platz für die Inserate. Scrollst du ein wenig nach oben, ist sie sofort wieder da – bereit für eine neue Suche.',
      cl_photoIcon_title: 'Fotosuche direkt in der Suchleiste',
      cl_photoIcon_desc: 'Die Suche mit einem Foto ist jetzt ein Kamera-Symbol direkt in der Suchleiste der Startseite: ein Tipp und du kannst ein Bild hochladen.',
      cl_stickyFilters_title: 'Filter bleiben sichtbar',
      cl_stickyFilters_desc: 'Am Computer bleibt die Filterspalte jetzt beim Scrollen stehen, so kannst du die Suche verfeinern, ohne nach oben zurückzukehren.',
      cl_yearValue_title: 'Wertverlauf nach Jahrgang',
      cl_yearValue_desc: 'Auf der Wert-Seite siehst du jetzt eine einfache Kurve: was ein Modell Jahrgang für Jahrgang wert ist. Und in jedem Inserat steht der Vergleich direkt drin, z.B. "Das ist ein 2017: Jahrgang 2017 liegt bei CHF 280, die 2019 bei CHF 500".',
      cl_yearFilter_title: 'Filter Modelljahr',
      cl_yearFilter_desc: 'Neu kannst du in den Suchfiltern den Jahrgang wählen und nur die Inserate sehen, die dieses Jahr nennen. Der Link mit dem Filter lässt sich teilen.',
      cl_noFlatsDeals_title: 'Keine Wohnungen mehr in den Top-Deals',
      cl_noFlatsDeals_desc: 'Wohnungen, Häuser und Grundstücke sind aus den Top-Deals und aus der Preisberechnung raus: kein "-54%" mehr auf einer 1.5-Zimmerwohnung. Echte Objekte wie ein Hometrainer bleiben natürlich drin.',
      cl_telegramMode_title: 'Telegram: du wählst, was ankommt',
      cl_telegramMode_desc: 'Im Alert-Formular wählst du jetzt sofort zwischen "Nur Top-Deals" und "Alle Inserate" — auch bevor du Telegram verbindest — und du kannst es bei bestehenden Alerts jederzeit ändern. Die Nachricht hat neu einen Button "Alle N Inserate ansehen" mit deinen Filtern.',
      cl_betterMedian_title: 'Genauere Durchschnittspreise',
      cl_betterMedian_desc: 'Der Durchschnitt und die typische Preisspanne vergleichen jetzt nur dasselbe Produkt: keine Spiele oder Zubehör mehr im Schnitt einer PS5. Defekte Inserate werden ausgeschlossen, und wenn zu wenige echte Vergleichsinserate da sind, zeigen wir keine Zahl statt einer falschen.',
      cl_betterCondition_title: 'Zuverlässigerer Zustand + Ricardo-Beschreibungen',
      cl_betterCondition_desc: 'Viel weniger falsche "Defekt"-Labels: der Zustand wird vorsichtiger und in allen Sprachen erkannt. Ausserdem haben Ricardo-Inserate jetzt die vollständige Beschreibung.',
      cl_alertPrice_desc: 'Lass dich nur benachrichtigen, wenn das Inserat in deiner Preisspanne liegt — Marktplatz, Kategorie und Kanton der Suche werden direkt übernommen. Und kein neues Inserat geht mehr verloren, auch wenn 50 auf einmal erscheinen.',
      cl_featuredTiers_title: 'Inserat hervorheben: jetzt in 3 Stufen',
      cl_featuredTiers_desc: 'Basis CHF 4.90 für 3 Tage, Standard CHF 8.90 für 7 Tage mit höherer Position, Premium CHF 14.90 für 7 Tage inklusive Startseite.',
      cl_photoLogin_title: 'Fotosuche nur mit Konto',
      cl_photoLogin_desc: 'Um Missbrauch zu vermeiden, braucht die Suche mit einem Foto jetzt ein kostenloses Konto.',
      cl_shareFilters_title: 'Gefilterte Suchen teilen',
      cl_shareFilters_desc: 'Preis, Marktplätze und Sortierung stehen jetzt in der Adresse: Link kopieren, teilen, und beim Neuladen bleibt alles erhalten.',
      relaxedNoticePrefix: 'Keine exakten Treffer für',
      relaxedNoticeSuffix: 'wir zeigen Ergebnisse für',
      refreshLabel: 'Aktualisieren',
      updatedLabel: 'Aktualisiert',
      dealsFound: 'Deals gefunden',
      noListingsInPeriod: 'Keine Inserate in diesem Zeitraum',
      marketplaceCount: 'Marktplätze',
      offersCount: 'Angebote',
      // Location
      nearbyTitle: '📍 Angebote in deiner Nähe anzeigen',
      nearbyDesc: '— Standort aktivieren, um Entfernung zu sehen',
      nearbyBtn: 'Aktivieren',
      distance: 'Entfernung',
      // Sections
      bestDeals: 'Beste Deals',
      latestListings: 'Neueste Inserate',
      auctionsTitle: 'Laufende Auktionen',
      auctionsPremiumLabel: 'Premium Auktionen (>CHF 500)',
      auctionsRegularLabel: 'Laufende Auktionen',
      discoverAllDeals: 'Alle Angebote entdecken',
      discoverAllListings: 'Alle Inserate entdecken',
      // Marketplace descriptions
      mpTuttiDesc: 'Grösster Schweizer Marktplatz',
      mpAnibisDesc: 'Romandie und darüber hinaus',
      mpRicardoDesc: 'Auktionen und Festpreise',
      mpShpockDesc: 'Digitaler Flohmarkt',
      mpEbayDesc: 'Auktionen und Direktkauf',
      integrated: 'Integriert ✓',
      searchOnLabel: 'Gleichzeitig suchen auf',
      trendingTitle: 'Gerade beliebt',
      suggestionPrefix: 'Meintest du', facetsLabelAll: 'Kategorien', facetsLabelAlso: 'Auch in', countryConfirmTitle: 'Dein Land', countryConfirmBody: 'Wir zeigen dir Inserate aus {{country}}. Stimmt das?', countryConfirmYes: 'Ja, weiter', countryConfirmChange: 'Anderes Land', categoryDroppedNotice: 'Keine Treffer in {{cat}} – wir zeigen alle Kategorien', categoryInferredLabel: 'Kategorie automatisch angewendet', categoryInferredRemove: 'Entfernen', searchInCategory: 'Suchen in',
      relatedLabel: 'Verwandte Suchen',
      browseCategories: 'Kategorien durchsuchen',
      discoverAllAuctions: 'Alle Auktionen',
      discoverAllAuctionsPremium: 'Premium Auktionen',
      // Badges
      justPosted: 'NEU EINGESTELLT',
      newArrival: 'Neu',
      auctionBadge: 'Auktion läuft',
      currentBid: 'Aktuelles Gebot',
      bids: 'Gebote',
      endsIn: 'Endet in',
      buyNowLabel: 'Sofort-Kaufen',
      verifiedDeal: 'Verifiziertes Angebot',
      verifiedDealShort: 'VERIFIZIERT',
      uncertainDeal: 'Unsicheres Angebot',
      uncertainDealShort: 'PRÜFEN',
      priceTrend: 'Medianpreis',
      // CTA
      viewOffer: '🔥 Angebot ansehen',
      details: 'Details',
      open: 'Öffnen',
      save: 'Speichern',
      saved2: 'Gespeichert',
      alertBtn: 'Alarm',
      // Search
      searchPlaceholder: 'MacBook, iPhone, PlayStation...',
      searchButton: 'Suchen',
      searchTitle: 'Secondhand-Angebote in der Schweiz',
      searchSubtitle: 'Tutti & Anibis in einer Suche',
      results: 'Ergebnisse',
      resultsFor: 'Ergebnisse für',
      noResults: 'Keine Ergebnisse gefunden',
      noResultsHint: 'Versuche andere Suchbegriffe oder suche direkt auf den Marktplätzen',
      mascotNoResultsTitle: 'Noch nichts… aber ich gebe nicht auf!',
      mascotNoResultsDesc: 'Erstelle einen Alarm – ich melde mich, sobald ich es finde.',
      mascotCreateAlert: 'Alarm erstellen',
      alertSuggest: 'Meintest du',
      alertSuggestUse: 'Übernehmen',
      alertPreviewLoading: 'Ich zähle die passenden Inserate…',
      alertPreviewCount: 'Heute finde ich {{count}} passende Inserate',
      alertPreviewRecent: '{{count}} in den letzten 7 Tagen',
      alertPreviewNone: 'Im Moment passt kein Inserat: versuche einfachere Wörter.',
      mascotSavedEmpty: 'Hier ist alles ruhig… speichere ein Inserat, um mich zu wecken!',
      mascotAlertsEmpty: 'Noch keine Alarme. Erstelle einen und ich melde mich, sobald etwas Neues auftaucht!',
      notFoundTitle: 'Hoppla… diese Seite finde ich nicht!',
      notFoundDesc: 'Ich habe überall geschnüffelt, aber diese Adresse gibt es nicht. Probieren wir es von der Startseite aus?',
      listingGoneTitle: 'Dieses Inserat ist weg!',
      listingGoneDesc: 'Wahrscheinlich wurde es verkauft oder entfernt. Keine Sorge: ich helfe dir, ein ähnliches zu finden.',
      goHomeBtn: 'Zur Startseite',
      searchRunning: 'Suche läuft...',
      searchRunningDesc: 'Inserate werden live von den Marktplätzen geladen...',
      firstSearchNote: 'Bei der ersten Suche werden Inserate direkt von den Marktplätzen geladen.',
      // Filters
      filters: 'Filter',
      minPrice: 'Min. Preis',
      maxPrice: 'Max. Preis',
      marketplaces: 'Marktplätze',
      category: 'Kategorie',
      allCategories: 'Alle Kategorien',
      sortBy: 'Sortieren nach',
      relevance: 'Relevanz',
      priceLow: 'Preis: aufsteigend',
      priceHigh: 'Preis: absteigend', endingSoonest: 'Endet bald',
      newest: 'Neueste',
      dealScore: 'Bestes Angebot',
      applyFilters: 'Anwenden',
      resetFilters: 'Zurücksetzen',
      // Listing
      viewListing: 'Anzeige öffnen',
      saveSearch: 'Suche speichern',
      searchSaved: 'Suche gespeichert',
      ago: 'vor',
      minute: 'Minute',
      minutes: 'Minuten',
      hour: 'Stunde',
      hours: 'Stunden',
      day: 'Tag',
      days: 'Tagen',
      new: 'NEU',
      // Deals
      dealsTitle: 'Beste Deals in der Schweiz',
      dealsSubtitle: 'Unterpreisige Angebote im Vergleich zum Marktwert',
      estimatedValue: 'Schätzwert',
      priceWindowLong: 'Durchschnitt aus {{months}} Monaten: weniger sichere Schätzung',
      priceWindowSeason: 'Inkl. gleiche Saison letztes Jahr: weniger sichere Schätzung',
      dealDiscount: 'unter Marktwert',
      // Newest
      newestTitle: 'Neueste Inserate',
      newestSubtitle: 'Frisch eingestellte Angebote',
      last5min: 'Letzte 5 Min.',
      last15min: 'Letzte 15 Min.',
      last1h: 'Letzte Stunde',
      last24h: 'Letzte 24 Std.',
      last7d: 'Letzte 7 Tage',
      allTime: 'Alle',
      // Saved
      savedTitle: 'Gespeicherte Suchen',
      savedSubtitle: 'Verwalte deine Suchen und Alarme',
      savedLoginRequired: 'Melde dich an, um deine gespeicherten Anzeigen, Suchen und Benachrichtigungen zu verwalten.',
      loginRequired: 'Melde dich an, um Anzeigen zu speichern',
      noSaved: 'Noch keine gespeicherten Suchen',
      createAlert: 'Alarm erstellen',
      deleteSearch: 'Löschen',
      recentSearches: 'Zuletzt gesucht',
      alertsSection: 'Alarme',
      savedSearchesSection: 'Gespeicherte Suchen',
      alertKeywordLabel: 'Suchbegriff *',
      alertEmailOptional: 'E-Mail (optional, für Benachrichtigungen)',
      alertMinPriceLabel: 'Mindestpreis CHF (optional)',
      alertMaxPriceLabel: 'Höchstpreis CHF (optional)',
      alertPriceRange: 'Preis',
      noAlerts: 'Noch keine Alarme. Erstelle einen Alarm für neue Inserate.',
      alertActive: 'Aktiv',
      cancel: 'Abbrechen',
      searchBtn: 'Suchen',
      deleted: 'Gelöscht',
      alertDeleted: 'Alarm gelöscht',
      alertCreated: 'Alarm erstellt',
      savedListingsSection: 'Gespeicherte Inserate',
      priceWatchesSection: 'Preis-Überwachungen',
      noPriceWatches: 'Keine aktiven Preis-Überwachungen.',
      noPriceWatchesHint: 'Öffne ein Inserat und nutze "Benachrichtigen bei Preissenkung" um eine zu erstellen.',
      currentPrice: 'Aktuell',
      targetPrice: 'Ziel',
      priceTargetReached: 'Preis erreicht',
      notified: 'Benachrichtigt',
      watching: 'Aktiv',
      soldLabel: 'Verkauft',
      editThreshold: 'Schwelle ändern',
      editThresholdPrompt: 'Neuer Schwellenpreis (CHF):',
      thresholdUpdated: 'Schwelle aktualisiert',
      invalidPrice: 'Ungültiger Preis',
      noSavedListings: 'Noch keine gespeicherten Inserate',
      digestModeInstant: 'Sofort',
      digestModeDaily: 'Tägliche Zusammenfassung (19:00)',
      digestModeLabel: 'Benachrichtigung',
      digestModeUpdated: 'Benachrichtigungsmodus aktualisiert',
      digestDailyDesc: 'Eine E-Mail pro Tag um 19:00 mit allen neuen Inseraten',
      digestInstantDesc: 'Sofortige Benachrichtigung alle 2 Stunden',
      // Also search on
      alsoSearch: 'Auch suchen auf',
      // Stats
      totalListings: 'Inserate',
      sources: 'Quellen',
      // Footer
      footerSlogan: 'Die Suchmaschine für Inserate in der Schweiz',
      footerDisclaimer: 'ScanMarket ist nicht mit den aufgeführten Marktplätzen verbunden',
      footerFeedback: 'Feedback',
      footerPrivacy: 'Datenschutz',
      footerDataTransparency: 'Anonyme Daten werden automatisch nach 24 Monaten gelöscht',
      footerChangelog: 'Neuigkeiten',
      footerHowItWorks: 'Wie es funktioniert',
      changelogTitle: 'Was ist neu',
      changelogSubtitle: 'Die neuesten Verbesserungen und Features auf ScanMarket',
      changelogFooter: 'Wir veröffentlichen regelmässig Updates — schau zurück für Neuigkeiten.',
      clKindFeature: 'Neu',
      clKindImprovement: 'Verbesserung',
      clKindFix: 'Fix',
      announcementLabel: 'Neu',
      announcementTitle: 'Marktpreis mit Zeitfenster je Kategorie und präzisere Suche nach Maßen (z. B. «12-24mm f2.8»)',
      appTeaserTitle: 'Wir arbeiten an einer App für iOS und Android',
      appTeaserBody: 'Bald gibt es Neuigkeiten. Bleib dran!',
      whatsNew: 'Neu',
      announcementCta: 'Entdecken',
      announcementDismiss: 'Schliessen',
      cl_aiDeal_title: 'KI-Filter gegen Fake-Angebote',
      cl_assistant_title: 'Dein persönlicher Assistent (Pro)',
      cl_assistant_desc: 'Frag ihn, ob ein Artikel seinen Preis wert ist: er antwortet mit den echten Preisen von Tutti, Anibis, Ricardo, Shpock und eBay Schweiz — und schreibt dir auf Wunsch die Verhandlungsnachricht an den Verkäufer.',
      cl_valuePhoto_title: 'Was ist mein Artikel wert? (Pro)',
      cl_valuePhoto_desc: 'Beschreibe oder fotografiere, was du verkaufen willst: wir sagen dir, zu welchem Preis er in der Schweiz wirklich verkauft wird. Das Foto wird nie gespeichert.',
      cl_waitBuy_title: 'Warten oder jetzt kaufen? (Pro)',
      cl_waitBuy_desc: 'Wir zeigen dir anhand unserer Preisverläufe, ob dieser Artikel normalerweise noch günstiger wird oder ob du besser sofort zuschlägst.',
      cl_autoRenew_title: 'Pro mit automatischer Verlängerung',
      cl_autoRenew_desc: 'Erster Monat CHF 5.90, danach CHF 5.40 pro Monat: kein manuelles Reaktivieren mehr, jederzeit mit einem Klick kündbar.',
      cl_priceAccuracy_title: 'Präzisere Preise und Preisalarme',
      cl_priceAccuracy_desc: 'Wir haben eine Ursache für falsche Preissenkungen behoben und Preisalarme kommen jetzt nur noch für Inserate, bei denen du sie selbst aktiviert hast.',
      cl_photoSearch_title: 'Mit einem Foto suchen',
      cl_photoSearch_desc: 'Neu: Kamera-Symbol im Suchfeld. Fotografiere einen Gegenstand oder lade ein Bild hoch — wir erkennen Produkt, Marke und Modell und zeigen dir passende Inserate auf allen Marktplätzen. Das Foto wird nur analysiert und sofort verworfen, nie gespeichert.',
      cl_typoFix_title: 'Tippfehler werden automatisch korrigiert',
      cl_typoFix_desc: 'Wer «plastation 5» oder «iphon 15» schreibt, sieht jetzt direkt die richtigen Ergebnisse — mit dem Hinweis, nach welchem Begriff gesucht wurde. Vorher gab es nur einen Vorschlag zum Anklicken.',
      cl_synonyms_title: 'Velo, Bici, Fahrrad — eine Suche, alle Sprachen',
      cl_synonyms_desc: 'Rund 60 neue Synonymgruppen mit echten Helvetismen: Velo, Töff, Töffli, Natel, Trottinett, Finken… Suche in deiner Sprache und finde Inserate in allen vier Landessprachen, inklusive Mehrzahlformen und Akzenten.',
      cl_relevance_title: 'Deutlich präzisere Suchergebnisse',
      cl_relevance_desc: 'Bei «PlayStation 5» erschienen früher auch 5.5-Zimmer-Wohnungen oder Schuhe Gr. 45. Jetzt müssen alle Suchwörter passen, Zahlen gehören zum Modell («iPhone 5» ≠ «iPhone 15») und der Titel zählt mehr als die Beschreibung.',
      cl_contentFilter_title: 'Keine Erotik- und Dienstleistungsanzeigen mehr',
      cl_contentFilter_desc: 'Erotische Massage- und Begleitanzeigen sowie ganze Dienstleistungs- und Stellenrubriken der Marktplätze werden herausgefiltert — Produkte wie Massagepistolen oder Massagesessel bleiben natürlich drin.',
      cl_dealsDedupe_title: 'Top-Deals ohne Duplikate',
      cl_dealsDedupe_desc: 'Fast identische Inserate desselben Verkäufers erscheinen nur noch einmal, ebenso Inserate, die gleichzeitig auf Tutti und Anibis veröffentlicht werden. Mehr Vielfalt pro Seite.',
      cl_moreListings_title: 'Viel mehr Inserate von Tutti und Anibis',
      cl_moreListings_desc: 'Nach einer technischen Umstellung lesen wir pro Durchlauf rund 20x mehr Inserate von Tutti.ch und Anibis.ch — neue Angebote landen schneller und vollständiger bei dir.',
      cl_infiniteScroll_title: 'Unendliches Scrollen auf Inserate-Seiten',
      cl_infiniteScroll_desc: 'Auf Top-Deals, Neueste, Auktionen und Suchergebnissen werden Inserate automatisch nachgeladen, während du scrollst — keine Klicks mehr auf Seite 2, 3, 4…',
      cl_dealsNewestFix_title: 'Top-Deals und Startseite: korrekte Sortierung und Mix',
      cl_dealsNewestFix_desc: 'Die Seite Top-Deals zeigt jetzt standardmässig die neuesten Inserate. Sektion „Neueste Inserate" auf der Startseite: ausgewogen zwischen Tutti, Anibis, Ricardo, Shpock und eBay statt nur einem Marktplatz.',
      cl_howItWorks_title: 'Neue Seite „Wie es funktioniert"',
      cl_howItWorks_desc: 'Eine einfache Seite, die in 4 Schritten erklärt, wie ScanMarket Inserate aus den 5 Schweizer Marktplätzen aggregiert. Ideal zum Teilen mit Leuten, die uns noch nicht kennen.',
      cl_seoSsr_title: 'Echte SEO — Inserate jetzt auch in Google sichtbar',
      cl_seoSsr_desc: 'ScanMarket erscheint jetzt in den Google-Suchergebnissen mit den richtigen Titeln und Vorschaubildern. Auch WhatsApp- und Telegram-Vorschauen zeigen Produktfoto und Preis, wenn du einen Link teilst.',
      cl_categoryPages_title: 'Eigene Kategorie-Seiten',
      cl_categoryPages_desc: 'Jede Kategorie hat jetzt ihre eigene Seite (z.B. /c/furniture) mit allen Inseraten, Statistiken und verwandten Kategorien — Klick auf eine Kategorie auf der Startseite öffnet sie direkt.',
      cl_subcategories_title: 'Unterkategorien-Filter',
      cl_subcategories_desc: 'Auf jeder Kategorie-Seite findest du jetzt schnell die Unterkategorien (z.B. innerhalb Möbel: Sofas, Stühle, Tische). Nur Unterkategorien mit mindestens 15 Inseraten werden angezeigt — weniger Lärm.',
      cl_newCats_title: '7 neue Kategorien',
      cl_newCats_desc: 'Immobilien, Baby & Kinder, Tiere, Antiquitäten & Kunst, Sammeln, Tickets & Gutscheine, Boote — vorher in „Sonstiges" versteckt, jetzt eigenständig durchsuchbar.',
      cl_sharePreview_title: 'Bessere Link-Vorschauen',
      cl_sharePreview_desc: 'Wenn du einen Inserat-Link auf WhatsApp, Telegram, Twitter oder Facebook teilst, siehst du jetzt das richtige Produktfoto und den Preis — nicht mehr nur das ScanMarket-Logo.',
      cl_anibisCats_title: 'Anibis: korrekte Kategorisierung',
      cl_anibisCats_desc: 'Anibis-Inserate wurden manchmal in die falsche Kategorie eingeordnet (z.B. unter „Sonstiges" anstatt „Möbel"). Jetzt korrekt — danke an alle, die das gemeldet haben.',
      cl_aiDeal_desc: 'Unsere KI prüft jedes Top-Angebot und erkennt versteckte Mängel, irreführende Titel oder Fälschungen. So siehst du nur echte Schnäppchen, mit einer kurzen Erklärung warum es ein guter Deal ist.',
      cl_privacy_title: 'Transparenz & Datenschutz (LPD/DSGVO)',
      cl_privacy_desc: 'Cookie-Einstellungen vollständig anpassbar. IP-Adressen werden immer anonymisiert. Anonyme Daten werden nach 24 Monaten automatisch gelöscht.',
      cl_nightMode_title: 'Schnellere Aktualisierung der Angebote',
      cl_nightMode_desc: 'Wir optimieren das Scraping der Marktplätze für schnellere Resultate am Morgen, wenn ihr neue Schnäppchen sucht.',
      cl_proUpsell_title: 'Intelligentere Pro-Vorschläge',
      cl_proUpsell_desc: 'Die Pro-Features werden dir genau dann gezeigt, wenn du sie brauchst — nicht mehr unnötige Banner.',
      cl_homepage_title: 'Neue Startseite mit mehr Angeboten',
      cl_homepage_desc: 'Die besten Deals stehen jetzt oben in voller Breite mit 16 Angeboten — finde schneller was du suchst.',
      cl_ghostAuction_title: 'Abgelaufene Auktionen ausgeblendet',
      cl_ghostAuction_desc: 'Bug behoben: Ricardo-Auktionen wurden nach Ablauf manchmal noch gezeigt. Jetzt werden sie zuverlässig entfernt.',
      cookieTitle: 'Wir respektieren Ihre Privatsphäre',
      cookieDesc: 'Wir verwenden anonyme Statistik-Cookies, um ScanMarket zu verbessern. Wir teilen niemals Ihre Daten.',
      cookiePrivacyLink: 'Datenschutzerklärung lesen',
      cookieLegalNote: 'LPD & DSGVO konform — IP-Adressen werden anonymisiert.',
      cookieAcceptBtn: 'Alle akzeptieren',
      cookieRejectBtn: 'Ablehnen',
      cookieSettingsLink: 'Cookie-Einstellungen',
      cookieCurrentStatus: 'Aktueller Status',
      privacyTitle: 'Datenschutzerklärung',
      privacyLastUpdated: 'Letzte Aktualisierung',
      privacyDate: 'April',
      privacyIntro: 'ScanMarket.ch respektiert Ihre Privatsphäre und hält das Schweizer Datenschutzgesetz (LPD/FADP) und die europäische DSGVO ein. Diese Erklärung beschreibt, welche Daten wir sammeln und warum.',
      privacyDataWeCollect: 'Welche Daten wir sammeln',
      privacyDataPageviews: 'Anonymisierte Seitenaufrufe (IP-Adresse auf /24 maskiert, kein Browser-Fingerprint ohne Einwilligung).',
      privacyDataAccount: 'Kontoinformationen bei Registrierung (E-Mail, Name) — nur mit Ihrer Einwilligung.',
      privacyDataSaved: 'Ihre gespeicherten Anzeigen und Benachrichtigungseinstellungen, nur wenn Sie angemeldet sind.',
      privacyDataPayments: 'Zahlungsinformationen werden ausschliesslich von Stripe verwaltet — wir speichern keine Kreditkartendaten.',
      privacyCookiesTitle: 'Cookies',
      privacyCookiesDesc: 'Wir verwenden eine minimale Anzahl von Cookies. Analyse-Cookies werden nur aktiviert, wenn Sie zustimmen.',
      privacyColName: 'Name',
      privacyColPurpose: 'Zweck',
      privacyColRetention: 'Aufbewahrung',
      privacyCookieSession: 'Session-ID für anonyme Nutzung',
      privacyCookieConsent: 'Speichert Ihre Cookie-Wahl',
      privacyCookieLang: 'Ihre Sprachpräferenz',
      privacyCookiePosthog: 'Anonyme Analytics (nur nach Zustimmung)',
      privacyRetSession: 'Sitzung',
      privacyRet60m: '60 Monate',
      privacyRet12m: '12 Monate',
      privacyCookiesChange: 'Sie können Ihre Präferenzen jederzeit ändern',
      privacyRightsTitle: 'Ihre Rechte',
      privacyRightsDesc: 'Gemäss DSGVO und LPD haben Sie folgende Rechte:',
      privacyRightAccess: 'Zugang zu Ihren personenbezogenen Daten',
      privacyRightErase: 'Löschung Ihrer Daten ("Recht auf Vergessenwerden")',
      privacyRightPortability: 'Datenportabilität',
      privacyRightObject: 'Widerspruch gegen die Verarbeitung',
      privacyContactTitle: 'Kontakt',
      privacyContactDesc: 'Für Anfragen zum Datenschutz schreiben Sie an',
      privacyLegalBasis: 'Rechtsgrundlage: Schweizer Bundesgesetz über den Datenschutz (LPD), EU DSGVO Art. 6(1)(a) Einwilligung und 6(1)(f) berechtigtes Interesse für anonyme Aggregate.',
      footerDataFrom: 'Daten von',
      // Conditions
      condNew: 'Neu',
      condLikeNew: 'Wie neu',
      condGood: 'Gut',
      condFair: 'Akzeptabel',
      condBroken: 'Defekt',
      // QuickView
      description: 'Beschreibung',
      translated: 'übersetzt',
      original: 'Original',
      translateTo: 'Übersetzen auf',
      detailsSection: 'Details',
      positionLabel: 'Standort',
      postalCode: 'PLZ',
      publishedAt: 'Veröffentlicht',
      detectedAt: 'erkannt am',
      conditionLabel: 'Zustand',
      brandLabel: 'Marke',
      saleTypeLabel: 'Verkaufstyp',
      categoryLabel: 'Kategorie',
      priceHistory: 'Preisverlauf',
      priceStable: 'Stabil',
      fromFirstRecord: 'seit der ersten Aufzeichnung',
      minLabel: 'Min',
      maxLabel: 'Max',
      priceRecordedOn: 'Preis erfasst am',
      priceGraphSoon: 'Das Diagramm erscheint mit mehr Aufzeichnungen.',
      priceCheckedOnOpen: 'Bei jedem Öffnen dieser Anzeige wird der Preis überprüft.',
      datePosted: 'Veröffentlicht auf der Originalseite',
      aiDisclaimer: 'Automatische Analyse — immer vor dem Kauf überprüfen.',
      aiBadgeTitle: 'KI-Analyse',
      aiBadgeAria: 'KI-Erklärung — tippe für den vollständigen Text',
      dateScraped: 'Zuletzt von ScanMarket erfasst',
      priceHistoryCollecting: 'Preisverlauf wird gesammelt...',
      priceHistoryProTitle: 'Preis-Alerts & Verlauf — Pro',
      priceHistoryProDesc: 'Erhalte Benachrichtigungen bei Preissenkungen und neuen Anzeigen. Inklusive Preisverlauf.',
      discoverPro: 'Pro entdecken',
      openOn: 'Öffnen auf',
      goToListingOn: 'Zur Anzeige auf',
      // Auctions page
      auctionPageTitle: 'Laufende Auktionen',
      auctionPageSubtitle: 'Ricardo.ch — Angebotspreise alle 2 Stunden aktualisiert',
      allAuctionsTab: 'Alle Auktionen',
      premiumAuctionsTab: '🏆 Premium Auktionen',
      priceRangeLabel: 'Preisbereich',
      filtersLabel: 'Filter', applyFilters: 'Anwenden', resetFilters: 'Filter zurücksetzen',
      allPrices: 'Alle',
      extraFilters: 'Weitere Filter',
      premiumOnly: 'Nur Premium (>CHF 500)',
      removePremiumFilter: 'Premium-Filter entfernen',
      premiumAuctionsTitle: 'Premium Auktionen',
      premiumAuctionsSubtitle: 'Aktuelles Gebot > CHF 500',
      noAuctionsPremium: 'Keine Premium-Auktionen gerade',
      auctionsCount: 'Auktionen',
      noAuctions: 'Keine Auktionen gefunden',
      removeFilters: 'Filter entfernen',
      // Alerts / Notifications
      createAlertTitle: '🔔 Alert erstellen',
      notificationsFor: 'Benachrichtigungen für',
      enterAtLeastOne: 'Bitte mindestens eine Benachrichtigungsmethode eingeben',
      telegramChatId: 'Telegram Chat ID',
      telegramIdHint: 'Schreibe /start an @ScanMarketChBot, um deine ID zu erhalten',
      activating: 'Wird erstellt...',
      activateNotifications: '🔔 Benachrichtigungen aktivieren',
      stayUpdated: '🔔 Bleib auf dem Laufenden',
      alertBannerText: 'Möchtest du benachrichtigt werden, wenn neue',
      alertBannerText2: 'erscheinen?',
      activateFreeAlert: 'Pro-Alert aktivieren',
      // Pro Modal
      proTitle: 'ScanMarket Pro',
      proUpgradeCta: '🚀 Pro aktivieren — CHF 9.90/Monat',
      proStripNote: 'Sichere Zahlung via Stripe · Jederzeit kündbar',
      proBenefitAlerts: 'E-Mail- und Telegram-Benachrichtigungen',
      proBenefitUnlimited: 'Bis zu 3 aktive Alerts für jedes Produkt',
      proBenefitHistory: 'Preisverlauf und Deal Score',
      // Featured
      promote: '⭐ Bewerben',
      featuredTitle: 'Anzeige hervorheben',
      featuredSubtitle: 'Haben Sie bereits eine Anzeige auf Tutti.ch, Ricardo.ch, Anibis.ch oder Shpock? Zeigen Sie sie allen ScanMarket-Besuchern.',
      featuredHow: 'Wie es funktioniert',
      featuredStep1: 'Link zur bestehenden Anzeige einfügen',
      featuredStep2: 'Automatische Vorschau prüfen',
      featuredStep3: 'Level wählen (CHF 4.90 / 8.90 / 14.90) und bezahlen — Badge, Top-Position und Startseite je nach Level',
      featuredProNote: 'Beim ersten Pro-Abo: 1 Hervorhebung gratis — Basis (CHF 4.90) monatlich, Standard (CHF 8.90) jährlich',
      featuredUrlLabel: 'URL deiner Anzeige *',
      featuredLoadPreview: 'Vorschau laden',
      featuredSupported: 'Unterstützt: Tutti.ch, Anibis.ch, Ricardo.ch, Shpock, eBay.ch',
      featuredPreviewLabel: 'Vorschau der Anzeige:',
      featuredProduct: 'Hervorhebung',
      featuredBenefit1: '✅ "Hervorgehoben"-Badge auf allen 5 Seiten: Startseite, Deals, Neueste, Auktionen, Suchergebnisse',
      featuredBenefit2: '✅ Immer ganz oben — vor allen normalen Anzeigen sichtbar',
      featuredBenefit3: '✅ 10 Tage Laufzeit, tausende potenzielle Kaufer pro Tag',
      featuredPayCta: '⭐ Bezahlen und hervorheben',
      featuredStripeNote: 'Sichere Zahlung via Stripe',
      featuredSuccessTitle: 'Anzeige hervorgehoben! 🎉',
      featuredSuccessText: 'Deine Anzeige erscheint für 10 Tage ganz oben in den Suchergebnissen.',
      featuredSuccessWhat: '✅ Was jetzt passiert:',
      featuredSuccessBadge: '⭐ Deine Anzeige hat das "Hervorgehoben"-Badge',
      featuredSuccessTop: '🔝 Oben in relevanten Suchanfragen angezeigt',
      featuredSuccessHome: '👥 Auf der ScanMarket-Startseite sichtbar',
      featuredBackHome: 'Zurück zur Startseite →',
      featuredCheckingPayment: 'Zahlung wird überprüft...',
      featuredWait: 'Bitte einen Moment warten',
      featuredPaymentFailed: 'Zahlung fehlgeschlagen',
      featuredRetry: 'Erneut versuchen',
      // General
      loading: 'Laden...',
      error: 'Fehler',
      retry: 'Erneut versuchen',
      chf: 'CHF',
      free: 'Gratis',
      // Homepage sections
      recentlyViewed: 'Kürzlich angesehen', recentlyViewedNewBadge: 'neu',
      clearAll: 'Alle löschen',
      confirmClearAll: 'Wirklich löschen?',
      forYou: 'Für dich',
      whatIsItWorth: 'Was ist es wert?',
      whatIsItWorthShort: 'Wert',
      menuGroupDiscover: 'Entdecken',
      menuGroupMine: 'Mein Konto',
      menuGroupSettings: 'Einstellungen',
      // QuickView
      checkingAvailability: 'Verfügbarkeit wird überprüft...',
      listingUnavailable: 'Diese Anzeige ist möglicherweise nicht mehr verfügbar',
      availabilityWarning: 'Die Verfügbarkeit konnte nicht überprüft werden — prüfe auf der Originalseite',
      loadingPhotos: 'Fotos werden geladen...',
      galleryTitle: 'Fotos', galleryClose: 'Schliessen', galleryPrev: 'Vorheriges Foto', galleryNext: 'Nächstes Foto', galleryOpen: 'Fotos im Vollbild ansehen',
      saveListing: 'Speichern',
      savedListing: 'Gespeichert',
      removedFromSaved: 'Aus Gespeicherten entfernt',
      listingSaved: 'Anzeige gespeichert!',
      limitReached: 'Limit erreicht — upgrade auf Pro',
      avgPriceForSimilar: 'Durchschnittspreis für ähnliche Artikel',
      yearContextLabel: 'Jahrgang',
      yearContextText: 'Das ist ein {{year}}: Jahrgang {{year}} liegt bei CHF {{median}}, die {{latestYear}} bei CHF {{latestMedian}}.',
      belowAverage: 'unter dem Durchschnitt',
      aboveAverage: 'über dem Durchschnitt',
      basedOnComparables: 'Basierend auf {{count}} ähnlichen Inseraten in der Datenbank',
      priceWatchTitle: 'Benachrichtigen bei Preissenkung',
      priceWatchNotify: 'Benachrichtigen',
      priceWatchSet: 'Wir benachrichtigen dich, wenn der Preis unter CHF {{price}} fällt',
      invalidPrice: 'Bitte einen gültigen Preis eingeben',
      priceWatchError: 'Fehler beim Erstellen der Benachrichtigung',
      similarListings: 'Könnte dich auch interessieren',
      reportSent: 'Meldung gesendet',
      reportUnavailable: 'Anzeige als nicht verfügbar melden',
      loginToReport: 'Melden Sie sich an, um eine Anzeige zu melden',
      signIn: 'Anmelden',
      alreadyReported: 'Du hast diese Anzeige bereits gemeldet',
      thanksReport: 'Danke für die Meldung!',
      reportError: 'Fehler bei der Meldung',
      linkCopied: 'Link kopiert!',
      copyFailed: 'Link konnte nicht kopiert werden',
      emailOptional: 'E-Mail (optional)',
      scrapingBanner: 'Aktualisierung der Anzeigen läuft — neue Ergebnisse in wenigen Sekunden...',
      // Push notification banner
      pushBannerTitle: 'Bleib auf dem Laufenden',
      pushBannerDesc: 'Erhalte sofortige Benachrichtigungen, wenn wir aussergewöhnliche Angebote für deine Suchen finden.',
      pushBannerActivate: 'Benachrichtigungen aktivieren',
      pushBannerActivating: 'Aktivierung...',
      pushBannerDismiss: 'Nicht jetzt',
      pushSuccess: 'Benachrichtigungen aktiviert!',
      pushErrorGeneric: 'Benachrichtigungen konnten nicht aktiviert werden',
      pushErrorDenied: 'Berechtigung vom Browser verweigert. Überprüfe die Website-Einstellungen.',
      pushErrorUnsupported: 'Dein Browser unterstützt keine Push-Benachrichtigungen',
      // Featured badge
      featuredLabel: 'Hervorgehoben',
      // Login modal
      loginTitle: 'Anmelden',
      registerTitle: 'Konto erstellen',
      forgotTitle: 'Passwort vergessen',
      continueGoogle: 'Weiter mit Google',
      googleDesc: 'Kein Passwort merken. Sicherer Zugang mit deinem Google-Konto.',
      loginSubmitBtn: 'Anmelden',
      forgotLink: 'Passwort vergessen?',
      registerLink: 'Registrieren →',
      namePlaceholder: 'Dein Name',
      passPlaceholder: 'Passwort (mind. 8 Zeichen)',
      passConfirmPlaceholder: 'Passwort bestätigen',
      createAccountBtn: 'Konto erstellen',
      haveAccount: 'Schon ein Konto?',
      forgotDesc: 'Gib deine E-Mail ein und wir senden dir einen Link zum Zurücksetzen des Passworts.',
      resetSubmitBtn: 'E-Mail senden',
      backToLogin: '← Zurück zur Anmeldung',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      passwordTooShort: 'Passwort mindestens 8 Zeichen',
      welcomeUser: 'Willkommen, {{name}}!',
      welcomeBack: 'Willkommen zurück, {{name}}!',
      welcomeNew: 'Willkommen bei ScanMarket, {{name}}!',
      resetSent: 'E-Mail gesendet an {{email}} — prüfe dein Postfach',
      googleError: 'Google-Login abgebrochen oder fehlgeschlagen',
      connectionError: 'Verbindungsfehler. Bitte versuche es erneut.',
      // Login nudge
      nudgeTitle: 'Angebote verfolgen',
      nudgeDesc: 'Speichere Inserate und erhalte Benachrichtigungen zu den besten Angeboten.',
      nudgeDismiss: 'Später',
      reportBtn: 'Melden',
      reportBtnDone: 'Gemeldet',
      unavailableShort: 'Nicht mehr verfügbar',
      radarOff: 'Radar deaktiviert für "{{keyword}}"',
      radarOn: 'Radar aktiv für "{{keyword}}" — du wirst bei ähnlichen Inseraten benachrichtigt',
      limitSavedPro: 'Limit erreicht — wechsle zu Pro für unbegrenzte Inserate',
      limitAlertPro: 'Die Alerts sind eine Pro-Funktion — wechsle zu Pro, um E-Mail-Benachrichtigungen für deine Lieblingsdeals zu erhalten',
      proUpsellAlertTitle: 'Verpasse nie wieder ein Schnäppchen',
      proUpsellAlertDesc: 'Mit Pro erhältst du automatische E-Mail-Alerts, sobald ein Inserat zu deinen Keywords erscheint.',
      proUpsellSavedTitle: 'Speichere so viele Inserate du willst',
      proUpsellSavedDesc: 'Mit Pro hast du keine Limits beim Speichern und findest deine Favoriten immer wieder.',
      proUpsellCompareTitle: 'Vergleiche Inserate Seite an Seite',
      proUpsellCompareDesc: 'Mit Pro kannst du mehrere Inserate nebeneinander stellen und die beste Wahl treffen.',
      proUpsellAnalyticsTitle: 'Detaillierte Preisanalysen',
      proUpsellAnalyticsDesc: 'Mit Pro siehst du Preisverlauf, Median und Marktstatistiken für jede Suche.',
      proUpsellPriceHistoryTitle: 'Preisverlauf im Detail',
      proUpsellPriceHistoryDesc: 'Mit Pro siehst du, wie sich der Preis jedes Inserats im Laufe der Zeit entwickelt hat.',
      proUpsellBenefitUnlimited: 'Unbegrenzte Inserate speichern',
      proUpsellBenefitAlerts: 'E-Mail-Alerts für neue Anzeigen und Preissenkungen',
      proUpsellBenefitPriceHistory: 'Preisverlauf und Markttrends',
      proUpsellBenefitNoAds: 'Keine Werbung, schnellerer Support',
      proUpsellForYou: '↑ für dich',
      proUpsellCta: 'Pro entdecken',
      proUpsellLater: 'Nicht jetzt',
      compareSelected: 'ausgewählt',
      compareReady: 'Bereit zum Vergleich',
      compareNeedMore: 'Wähle 2+ Inserate',
      compareCta: 'Vergleichen',
      compareClear: 'Auswahl leeren',
      compareTitle: 'Inseratvergleich',
      compareField: 'Feld',
      compareBestPrice: '(bester Preis)',
      compareEnableHint: 'Wähle Inserate aus, um sie zu vergleichen',
      compareModeOn: 'Vergleich beenden',
      compareModeOff: 'Vergleichen (Pro)',
      openedOnSource: 'Geöffnet auf {{source}}',
      scanmarketHere: 'ScanMarket bleibt hier für dich',
      fromYou: 'von dir',
      verifiedDealTooltip: 'Mit {{count}}+ ähnlichen Produkten zu einheitlichen Preisen verglichen. Hohe Zuverlässigkeit.',
      uncertainDealTooltip: 'Vergleichspreise variieren — überprüfe auf dem Marktplatz.',
      medianTooltip: 'Medianwert aus ähnlichen Inseraten in der Datenbank',
      dealCalcTooltip: 'Wie berechnen wir den Schätzwert?',
      dealCalcDesc: 'Wir vergleichen den Preis mit ähnlichen Inseraten nach Titel und Kategorie.',
      estValueLabel: 'Geschätzter Wert',
      verifyAvailability: 'Verfügbarkeit prüfen',
      aboutDaysAgo: '~{{days}}T',
      loginToReportToast: 'Melde dich an, um ein Inserat zu melden',
      reportAlreadyDone: 'Du hast dieses Inserat bereits gemeldet',
      reportThanks: 'Danke für die Meldung!',
      reportErrorToast: 'Fehler bei der Meldung',
      close: 'Schliessen',
    }
  },
  fr: {
    translation: {
      home: 'Recherche',
      deals: 'Meilleures Offres',
      newest: 'Récentes',
      saved: 'Enregistré',
      auctions: 'Enchères',
      login: 'Se connecter',
      signupOrLogin: 'Inscription / Connexion',
      proActiveMenu: 'Pro actif',
      proUpgradeMenu: 'Passer à Pro',

      logout: 'Se déconnecter',
      settings: 'Paramètres',
      heroTitle: 'Trouvez les meilleures affaires\nen Suisse',
      heroSubtitle: 'ScanMarket est un agrégateur qui vous permet de rechercher simultanément sur Ricardo, Tutti, Anibis, Shpock et eBay Suisse.',
      heroTagline: 'Trouvez l\'affaire avant tout le monde.',
      liveUpdateBadge: 'Live · annonces mises à jour en temps réel',
      headerLiveText: 'mis à jour',
      heroSearchBtn: 'Rechercher',
      listingsCount: 'annonces',
      apiDownMsg: 'Le service est momentanément indisponible. Nous y travaillons — merci de réessayer dans un instant.',
      apiDownRetry: 'Réessayer',
      similarResultsTitle: 'Annonces similaires',
      similarResultsHint: 'sans mention électrique, pour «{q}»',
      correctedNoticePrefix: 'Résultats pour',
      correctedNoticeSuffix: 'rechercher plutôt',
      imageSearchTitle: 'Rechercher par photo',
      imageSearchAnalyzing: 'Analyse de la photo…',
      imageSearchFound: 'Identifié',
      imageSearchNotRecognized: 'Objet non reconnu — essayez une autre photo',
      imageSearchFormatError: 'Uniquement JPG, PNG ou WEBP',
      imageSearchTooLarge: 'Photo trop lourde (max. 6 Mo)',
      imageSearchError: 'La recherche par photo a échoué',
      photoSearchCardTitle: 'Rechercher avec une photo',
      photoSearchCardDesc: 'Prenez ou déposez une photo — nous trouvons l\'objet sur tous les sites.',
      photoSearchCardCta: 'Choisir une photo',
      photoSearchCardBadge: 'Nouveau',
      copyFilterLink: 'Copier le lien',
      photoSearchLoginRequired: 'Connectez-vous pour rechercher avec une photo',
      shareOnWhatsapp: 'Partager sur WhatsApp',
      shareOnTelegram: 'Partager sur Telegram',
      cl_priceArchive_title: 'Prix du marché avec fenêtre par catégorie',
      cl_priceArchive_desc: "La réduction des meilleures offres est maintenant comparée aussi aux annonces déjà vendues ou expirées, avec une fenêtre par catégorie : 90 jours pour l'électronique, jusqu'à 6 mois pour les véhicules, jusqu'à 12 mois pour instruments de musique, outils et montres, la même saison de l'an dernier pour les vélos et articles de sport saisonniers. La fenêtre ne s'élargit que s'il y a moins de 20 annonces similaires, et tu le vois dans l'annonce.",
      cl_specSearch_title: 'Recherche plus précise pour les mesures et objectifs',
      cl_specSearch_desc: "« Sony 12 - 24mm », « 12–24 mm » ou « f2.8 » sont maintenant compris comme « 12-24mm » et « F/2,8 » : tu trouves l'objectif quelle que soit l'écriture. Et la recherche reste rapide même pour les demandes rares.",
      cl_dealsFast_title: 'Meilleures offres plus rapides et plus propres',
      cl_dealsFast_desc: "Les meilleures offres s'ouvrent beaucoup plus vite et n'affichent plus d'immobilier, d'animaux ni de chaussures d'occasion : seulement des objets vraiment comparables au prix du marché.",
      cl_noReload_title: 'Plus de rechargement au retour',
      cl_noReload_desc: "Si tu ouvres une annonce sur le site d'origine pendant une recherche et que tu reviens, la page ne se recharge plus et la recherche ne repart pas de zéro : elle continue simplement.",
      cl_gallery_title: "Photos en plein écran, comme dans une app",
      cl_gallery_desc: "Touche la photo d'une annonce : glisse d'une image à l'autre, zoome à deux doigts ou d'un double appui et glisse vers le bas pour fermer. Les miniatures sont en bas.",
      cl_back_title: "« Retour » ramène aux résultats",
      cl_back_desc: "Sur mobile (bouton retour ou balayage sur iPhone), depuis une annonce tu reviens maintenant aux résultats et non plus à l'accueil.",
      cl_centerView_title: "Annonce au centre de l'écran",
      cl_centerView_desc: "Sur ordinateur, l'annonce s'ouvre au centre dans une fenêtre plus grande, au lieu du bord droit.",
      cl_autoScroll_title: "Plus d'annonces automatiquement",
      cl_autoScroll_desc: "En bas de page, les nouvelles annonces se chargent toutes seules : plus de bouton « Charger plus ».",
      cl_typoCategory_title: "Fautes de frappe : bonne catégorie",
      cl_typoCategory_desc: "Si tu tapes « ipune » ou « mercedesschwarz », on corrige le mot et on met la catégorie du mot correct (Smartphone, Auto…). Et la recherche est plus rapide.",
      cl_yearSearch_title: "Recherche avec l'année",
      cl_yearSearch_desc: "« iMac 2019 » ou « Golf 2015 » trouvent maintenant aussi les titres avec d'autres mots au milieu, comme « iMac 27\" Retina 5K 2019 ».",
      cl_auctionReminder_title: "Rappel 1 heure avant la fin d'une enchère (Pro)",
      cl_auctionReminder_desc: "Appuie sur ⏰ sur une enchère ou enregistre-la : environ 1 heure avant la fin, tu reçois un message sur Telegram et/ou par e-mail, avec photo, offre actuelle et prix d'achat immédiat. Choisis le canal dans Enregistrés.",
      cl_ricardoPrices_title: "Enchères Ricardo : prix corrigés",
      cl_ricardoPrices_desc: "Sur certaines enchères Ricardo s'affichait le prix d'une annonce similaire. Désormais, l'offre actuelle et l'achat immédiat sont lus uniquement sur l'enchère elle-même.",
      cl_shareOne_title: "Un seul bouton « Partager »",
      cl_shareOne_desc: "WhatsApp, Telegram et Copier le lien sont réunis dans un seul bouton « Partager » : plus de place au-dessus des résultats.",
      cl_compactResults_title: "Résultats plus compacts sur mobile",
      cl_compactResults_desc: "Moins d'espace avant la première annonce : catégories et recherches liées sur une ligne, tous les boutons sur une rangée, et la barre du haut n'est plus coupée.",
      shareSearch: 'Partager',
      shareMoreApps: 'Autres applis…',
      medianShort: 'Médiane',
      cl_photoWidget_title: 'Recherche par photo mise en avant',
      cl_photoWidget_desc: 'Nouveau bloc sous la barre de recherche : prenez ou glissez une photo et voyez aussitôt les annonces correspondantes.',
      cl_newPricing_title: 'Nouveaux plans Pro : mensuel ou annuel',
      cl_newPricing_desc: 'Pro à CHF 9.90 par mois ou CHF 99 par an (deux mois offerts). Au premier abonnement, une mise en avant offerte. Les anciens abonnés gardent leur prix.',
      cl_telegramOneTap_title: 'Alertes Telegram en un tap',
      cl_telegramOneTap_desc: 'Plus aucun Chat ID à copier : appuie sur "Connecter Telegram", puis sur Démarrer dans le bot — c\'est fait. Tu reçois les 3 meilleures annonces avec photo et un résumé des autres, sans saturer ton chat. Fonction Pro.',
      cl_alertPrice_title: 'Alertes avec prix max et tes filtres',
      cl_alertPreview_title: 'Aperçu à la création d\'une alerte',
      cl_alertPreview_desc: 'Quand vous créez une alerte, vous voyez tout de suite combien d\'annonces correspondent aujourd\'hui et combien sont arrivées ces 7 derniers jours. Si rien ne correspond, nous vous suggérons des mots plus simples.',
      cl_tgVolume_title: "Telegram : tu choisis combien d'affaires",
      cl_tgVolume_desc: "Pour les meilleures offres sur Telegram, choisis maintenant Peu (3 à la fois), Beaucoup (10) ou Toutes. Au-delà de la limite, tu reçois « +N autres affaires » avec le lien vers la liste complète — aucune affaire perdue.",
      cl_tgDeals_title: "Meilleures offres sur Telegram (Pro)",
      cl_tgDeals_desc: "Les nouvelles bonnes affaires directement dans Telegram : photo, prix, réduction et bouton vers le vendeur. Choisis catégories, réduction minimale et prix maximum dans « Mes alertes ».",
      cl_fastAlerts_title: "Alertes toutes les 10 minutes",
      cl_fastAlerts_desc: "Les alertes Pro sont vérifiées toutes les 10 minutes et peuvent prévenir toutes les 30 minutes. Les recherches Pro rechargent les sites toutes les 30 minutes.",
      cl_carSpecs_title: "Voitures : année et kilomètres",
      cl_carSpecs_desc: "Les fiches voiture et moto affichent l'année et le kilométrage. Le filtre année ignore désormais les dates comme « dernier service 2023 ».",
      cl_newOnTop_title: "Nouvelles annonces toujours en haut",
      cl_newOnTop_desc: "Si tu restes sur les résultats, les nouvelles annonces apparaissent en haut avec l'avis « nouvelles annonces » — plus jamais en bas de la liste.",
      cl_autocomplete_title: 'Suggestions pendant la saisie',
      cl_autocomplete_desc: 'Dès que tu commences à écrire, nous te proposons les recherches les plus populaires et tes dernières recherches – avec la bonne catégorie à côté (p. ex. « iphone 13 dans Smartphones »). Touche le champ vide pour voir les tendances du moment.',
      cl_instantSearch_title: 'Recherche ultra-rapide',
      cl_instantSearch_desc: 'Les résultats s\'affichent désormais quasi instantanément – même pour les mots avec synonymes (« canapé », « vélo ») et les recherches de deux mots. Et quand beaucoup de monde cherche en même temps, le site reste fluide.',
      cl_newListingsPill_title: 'Nouvelles annonces sans interruption',
      cl_newListingsPill_desc: 'Pendant que Vulpi parcourt les marketplaces à la recherche de nouvelles annonces, ta liste ne bouge pas. S\'il trouve quelque chose, « X nouvelles annonces » apparaît en haut : un clic suffit pour les voir, mises en évidence.',
      cl_alertSuggest_title: 'Suggestion pour les mots collés',
      cl_alertSuggest_desc: 'Si vous écrivez « iPhone 12mini » ou « golf7 », nous vous proposons en un clic la bonne version (« 12 mini », « golf 7 ») pour ne manquer aucune annonce.',
      cl_smartSearch_title: 'Recherche plus tolérante',
      cl_smartSearch_desc: 'La recherche comprend maintenant les mots collés : « golf7 » donne les mêmes résultats que « golf 7 ». Et « Apple iPhone » trouve aussi les annonces où il n\'est écrit que « iPhone ».',
      cl_preciseAlerts_title: 'Des alertes plus précises',
      cl_preciseAlerts_desc: 'Les alertes ne tiennent compte que des mots entiers : une alerte « Kare » ne signale plus une « Schubkarre ». Et une alerte « iPhone 12mini » trouve maintenant aussi les annonces « 12 mini ». Valable pour toutes les alertes existantes.',
      cl_vulpi_title: 'Voici Vulpi !',
      cl_vulpi_desc: 'ScanMarket a une mascotte : Vulpi, un renard qui flaire les bonnes affaires pour vous. Vous le croiserez quand une recherche ne trouve rien, dans vos annonces sauvegardées et vos alertes, sur la page Pro et sur une nouvelle page d\'erreur quand une adresse n\'existe pas ou qu\'une annonce est vendue.',
      cl_newLogo_title: 'Nouveau logo',
      cl_newLogo_desc: 'Le logo est maintenant la tête de Vulpi avec la loupe rouge suisse, bien visible aussi en mode sombre. Le renard est aussi la nouvelle icône dans l\'onglet du navigateur et sur l\'écran d\'accueil du téléphone.',
      cl_vulpiAlerts_title: 'Les alertes signées Vulpi',
      cl_vulpiAlerts_desc: 'Les e-mails d\'alerte et les messages Telegram arrivent maintenant de la part de Vulpi : « J\'ai flairé 3 nouvelles annonces pour vous ! ». Notre bot Telegram a aussi une nouvelle photo de profil.',
      cl_loginFox_title: 'Le renard à la connexion',
      cl_loginFox_desc: 'À la connexion et à l\'inscription, Vulpi suit votre souris des yeux, vous regarde écrire et se cache les yeux quand vous tapez votre mot de passe.',
      cl_smartBar_title: 'Une barre de recherche qui vous suit',
      cl_smartBar_desc: 'Quand vous descendez, la barre du haut disparaît pour laisser plus de place aux annonces. Remontez un peu et elle réapparaît aussitôt, prête pour une nouvelle recherche.',
      cl_photoIcon_title: 'Recherche par photo dans la barre',
      cl_photoIcon_desc: 'La recherche avec une photo est maintenant une icône appareil photo directement dans la barre de recherche de l\'accueil : un clic et vous chargez une image.',
      cl_stickyFilters_title: 'Les filtres restent visibles',
      cl_stickyFilters_desc: 'Sur ordinateur, la colonne des filtres reste maintenant en place quand vous faites défiler la page : vous affinez la recherche sans remonter.',
      cl_yearValue_title: 'Courbe de valeur par année',
      cl_yearValue_desc: 'Sur la page Valeur, une courbe simple montre ce que vaut un modèle année après année. Et dans chaque annonce tu vois la comparaison directe, par ex. « C\'est un 2017 : les 2017 sont à CHF 280, les 2019 à CHF 500 ».',
      cl_yearFilter_title: 'Filtre année du modèle',
      cl_yearFilter_desc: 'Tu peux maintenant choisir l\'année dans les filtres de recherche et ne voir que les annonces qui indiquent cette année. Le lien avec le filtre est partageable.',
      cl_noFlatsDeals_title: 'Plus d\'appartements dans les meilleures affaires',
      cl_noFlatsDeals_desc: 'Appartements, maisons et terrains sont exclus des meilleures affaires et du calcul des prix : fini le « -54% » sur un 1,5 pièces. Les vrais objets, comme un vélo d\'appartement, restent bien sûr là.',
      cl_telegramMode_title: 'Telegram : tu choisis ce que tu reçois',
      cl_telegramMode_desc: 'Dans le formulaire d\'alerte tu choisis tout de suite entre « Meilleures affaires » et « Toutes les annonces » — même avant de connecter Telegram — et tu peux le changer sur une alerte existante. Le message a un nouveau bouton « Voir les N annonces » avec tes filtres.',
      cl_betterMedian_title: 'Des prix moyens plus justes',
      cl_betterMedian_desc: 'La moyenne et la fourchette de prix comparent désormais uniquement le même produit : plus de jeux ni d\'accessoires dans la moyenne d\'une PS5. Les annonces défectueuses sont exclues, et s\'il y a trop peu de vraies annonces comparables, on n\'affiche aucun chiffre plutôt qu\'un chiffre faux.',
      cl_betterCondition_title: 'État plus fiable + descriptions Ricardo',
      cl_betterCondition_desc: 'Beaucoup moins de faux "Défectueux" : l\'état est détecté avec plus de prudence et dans toutes les langues. Et les annonces Ricardo affichent maintenant la description complète.',
      cl_alertPrice_desc: 'Sois averti seulement si l\'annonce est dans ta fourchette de prix — le site reprend aussi le marketplace, la catégorie et le canton de ta recherche. Et plus aucune nouvelle annonce perdue, même s\'il en sort 50 d\'un coup.',
      cl_featuredTiers_title: 'Mise en avant : 3 niveaux',
      cl_featuredTiers_desc: 'Base CHF 4.90 pour 3 jours, Standard CHF 8.90 pour 7 jours avec position plus haute, Premium CHF 14.90 pour 7 jours avec la page d\'accueil.',
      cl_photoLogin_title: 'Recherche par photo réservée aux comptes',
      cl_photoLogin_desc: 'Pour éviter les abus, la recherche avec une photo demande désormais un compte gratuit.',
      cl_shareFilters_title: 'Partager une recherche filtrée',
      cl_shareFilters_desc: 'Prix, sites et tri figurent désormais dans l\'adresse : copiez le lien, partagez-le, et tout reste en place après actualisation.',
      relaxedNoticePrefix: 'Aucun résultat exact pour',
      relaxedNoticeSuffix: 'nous affichons les résultats pour',
      refreshLabel: 'Actualiser',
      updatedLabel: 'Mis à jour',
      dealsFound: 'deals trouvés',
      noListingsInPeriod: 'Aucune annonce sur cette période',
      marketplaceCount: 'marketplaces',
      offersCount: 'offres',
      nearbyTitle: '📍 Afficher les offres près de chez vous',
      nearbyDesc: '— Activez la localisation pour voir les distances',
      nearbyBtn: 'Activer',
      distance: 'Distance',
      bestDeals: 'Meilleures Offres',
      latestListings: 'Dernières Annonces',
      auctionsTitle: 'Enchères en Cours',
      auctionsPremiumLabel: 'Enchères Premium (>CHF 500)',
      auctionsRegularLabel: 'Enchères en Cours',
      discoverAllDeals: 'Voir toutes les offres',
      discoverAllListings: 'Voir toutes les annonces',
      discoverAllAuctions: 'Toutes les enchères',
      discoverAllAuctionsPremium: 'Enchères Premium',
      mpTuttiDesc: 'Le plus grand marché suisse',
      mpAnibisDesc: 'Romandie et au-delà',
      mpRicardoDesc: 'Enchères et prix fixes',
      mpShpockDesc: 'Brocante numérique',
      mpEbayDesc: 'Enchères et achats directs',
      integrated: 'Intégré ✓',
      searchOnLabel: 'Rechercher simultanément sur',
      trendingTitle: 'Tendances du moment',
      suggestionPrefix: 'Vouliez-vous dire', facetsLabelAll: 'Catégories', facetsLabelAlso: 'Aussi dans', countryConfirmTitle: 'Votre pays', countryConfirmBody: 'Nous affichons les annonces de {{country}}. C\'est bien ça ?', countryConfirmYes: 'Oui, continuer', countryConfirmChange: 'Autre pays', categoryDroppedNotice: 'Aucun résultat dans {{cat}} – nous affichons toutes les catégories', categoryInferredLabel: 'Catégorie appliquée automatiquement', categoryInferredRemove: 'Retirer', searchInCategory: 'Chercher dans',
      relatedLabel: 'Recherches liées',
      browseCategories: 'Parcourir les catégories',
      justPosted: 'NOUVEAU',
      newArrival: 'Nouveau',
      auctionBadge: 'Enchère en cours',
      currentBid: 'Offre actuelle',
      bids: 'offres',
      endsIn: 'Se termine dans',
      buyNowLabel: 'Achat immédiat',
      verifiedDeal: 'Offre vérifiée',
      verifiedDealShort: 'VÉRIFIÉE',
      uncertainDeal: 'Offre incertaine',
      uncertainDealShort: 'À VÉRIFIER',
      priceTrend: 'Prix médian',
      viewOffer: '🔥 Voir l\'offre',
      details: 'Détails',
      open: 'Ouvrir',
      save: 'Sauvegarder',
      saved2: 'Sauvegardé',
      alertBtn: 'Alerte',
      searchPlaceholder: 'MacBook, iPhone, PlayStation...',
      searchButton: 'Rechercher',
      searchTitle: 'Trouvez des occasions en Suisse',
      searchSubtitle: 'Tutti & Anibis en une seule recherche',
      results: 'Résultats',
      resultsFor: 'résultats pour',
      noResults: 'Aucun résultat trouvé',
      noResultsHint: 'Essayez d\'autres termes ou cherchez directement sur les marketplaces',
      mascotNoResultsTitle: 'Rien pour l\'instant… mais je n\'abandonne pas !',
      mascotNoResultsDesc: 'Crée une alerte et je te préviens dès que je le trouve.',
      mascotCreateAlert: 'Créer une alerte',
      alertSuggest: 'Vouliez-vous dire',
      alertSuggestUse: 'Utiliser',
      alertPreviewLoading: 'Je compte les annonces correspondantes…',
      alertPreviewCount: 'Aujourd\'hui je trouve {{count}} annonces correspondantes',
      alertPreviewRecent: '{{count}} ces 7 derniers jours',
      alertPreviewNone: 'Aucune annonce ne correspond pour l\'instant : essayez des mots plus simples.',
      mascotSavedEmpty: 'Tout est calme ici… sauvegarde une annonce pour me réveiller !',
      mascotAlertsEmpty: 'Aucune alerte pour l\'instant. Crées-en une et je te préviens dès qu\'il y a du nouveau !',
      notFoundTitle: 'Oups… je ne trouve pas cette page !',
      notFoundDesc: 'J\'ai flairé partout, mais cette adresse n\'existe pas. On repart de l\'accueil ?',
      listingGoneTitle: 'Cette annonce a disparu !',
      listingGoneDesc: 'Elle a sûrement été vendue ou retirée. Pas de souci : je t\'aide à en trouver une similaire.',
      goHomeBtn: 'Retour à l\'accueil',
      searchRunning: 'Recherche en cours...',
      searchRunningDesc: 'Annonces chargées en direct depuis les marketplaces...',
      firstSearchNote: 'Lors de la première recherche, les annonces sont chargées directement depuis les marketplaces.',
      filters: 'Filtres',
      minPrice: 'Prix min.',
      maxPrice: 'Prix max.',
      marketplaces: 'Marketplaces',
      category: 'Catégorie',
      allCategories: 'Toutes les catégories',
      sortBy: 'Trier par',
      relevance: 'Pertinence',
      priceLow: 'Prix croissant',
      priceHigh: 'Prix décroissant', endingSoonest: 'Termine bientôt',
      newest: 'Plus récent',
      dealScore: 'Meilleures offres',
      applyFilters: 'Appliquer',
      resetFilters: 'Réinitialiser',
      viewListing: 'Voir l\'annonce',
      saveSearch: 'Sauvegarder',
      searchSaved: 'Recherche sauvegardée',
      ago: 'il y a',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'heure',
      hours: 'heures',
      day: 'jour',
      days: 'jours',
      new: 'NOUVEAU',
      dealsTitle: 'Meilleures Offres en Suisse',
      dealsSubtitle: 'Annonces sous-évaluées vs. valeur marchande',
      estimatedValue: 'Valeur estimée',
      priceWindowLong: 'Moyenne sur {{months}} mois : estimation moins sûre',
      priceWindowSeason: "Incl. même saison l'an dernier : estimation moins sûre",
      dealDiscount: 'sous valeur marchande',
      newestTitle: 'Annonces récentes',
      newestSubtitle: 'Fraîchement publiées',
      last5min: '5 dernières min.',
      last15min: '15 dernières min.',
      last1h: 'Dernière heure',
      last24h: '24 dernières h.',
      last7d: '7 derniers jours',
      allTime: 'Tous',
      savedTitle: 'Recherches sauvegardées',
      savedSubtitle: 'Gérez vos recherches et alertes',
      savedLoginRequired: 'Connectez-vous pour voir et gérer vos annonces sauvegardées, recherches et alertes.',
      loginRequired: 'Connectez-vous pour sauvegarder des annonces',
      noSaved: 'Aucune recherche sauvegardée',
      createAlert: 'Créer alerte',
      deleteSearch: 'Supprimer',
      recentSearches: 'Recherches récentes',
      alertsSection: 'Alertes', savedSearchesSection: 'Recherches sauvegardées',
      alertKeywordLabel: 'Terme de recherche *', alertEmailOptional: 'E-mail (optionnel, pour les notifications)',
      alertMinPriceLabel: 'Prix minimum CHF (optionnel)',
      alertMaxPriceLabel: 'Prix maximum CHF (optionnel)',
      alertPriceRange: 'Prix',
      noAlerts: 'Aucune alerte. Créez une alerte pour les nouvelles annonces.',
      alertActive: 'Actif', cancel: 'Annuler', searchBtn: 'Rechercher',
      deleted: 'Supprimé', alertDeleted: 'Alerte supprimée', alertCreated: 'Alerte créée',
      savedListingsSection: 'Annonces sauvegardées', noSavedListings: 'Aucune annonce sauvegardée',
      priceWatchesSection: 'Alertes de prix',
      noPriceWatches: 'Aucune alerte de prix active.',
      noPriceWatchesHint: 'Ouvre une annonce et utilise "M\'avertir si le prix baisse" pour en créer une.',
      currentPrice: 'Actuel',
      targetPrice: 'Cible',
      priceTargetReached: 'Prix atteint',
      notified: 'Notifié',
      watching: 'Actif',
      soldLabel: 'Vendu',
      editThreshold: 'Modifier le seuil',
      editThresholdPrompt: 'Nouveau prix seuil (CHF):',
      thresholdUpdated: 'Seuil mis à jour',
      invalidPrice: 'Prix invalide',
      digestModeInstant: 'Instantané',
      digestModeDaily: 'Résumé quotidien (19h00)',
      digestModeLabel: 'Notification',
      digestModeUpdated: 'Mode de notification mis à jour',
      digestDailyDesc: 'Un e-mail par jour à 19h00 avec toutes les nouvelles annonces',
      digestInstantDesc: 'Notification instantanée toutes les 2 heures',
      alsoSearch: 'Aussi sur',
      totalListings: 'annonces',
      sources: 'sources',
      footerSlogan: 'Le moteur de recherche des petites annonces en Suisse',
      footerDisclaimer: 'ScanMarket n\'est pas affilié aux marketplaces listés',
      footerFeedback: 'Feedback',
      footerPrivacy: 'Confidentialité',
      footerDataTransparency: 'Les données anonymes sont automatiquement supprimées après 24 mois',
      footerChangelog: 'Nouveautés',
      footerHowItWorks: 'Comment ça marche',
      changelogTitle: 'Quoi de neuf',
      changelogSubtitle: 'Les dernières améliorations et fonctionnalités de ScanMarket',
      changelogFooter: 'Nous publions régulièrement des mises à jour — reviens pour plus de nouveautés.',
      clKindFeature: 'Nouveau',
      clKindImprovement: 'Amélioration',
      clKindFix: 'Correction',
      announcementLabel: 'Nouveau',
      announcementTitle: 'Prix du marché avec fenêtre par catégorie et recherche plus précise pour les mesures (ex. « 12-24mm f2.8 »)',
      appTeaserTitle: 'Nous travaillons sur une application iOS et Android',
      appTeaserBody: 'Des nouvelles arrivent bientôt. Restez à l\'écoute !',
      whatsNew: 'Nouveautés',
      announcementCta: 'Découvrir',
      announcementDismiss: 'Fermer',
      cl_aiDeal_title: 'Filtre IA contre les fausses bonnes affaires',
      cl_assistant_title: 'Votre assistant personnel (Pro)',
      cl_assistant_desc: 'Demandez-lui si un article vaut son prix : il répond avec les vrais prix de Tutti, Anibis, Ricardo, Shpock et eBay Suisse — et vous écrit même le message de négociation.',
      cl_valuePhoto_title: 'Combien vaut mon article ? (Pro)',
      cl_valuePhoto_desc: 'Décrivez ou photographiez ce que vous vendez : nous vous disons à quel prix il se vend vraiment en Suisse. La photo n\'est jamais conservée.',
      cl_waitBuy_title: 'Attendre ou acheter maintenant ? (Pro)',
      cl_waitBuy_desc: 'Grâce à nos historiques de prix, nous vous disons si cet article baisse encore d\'habitude ou s\'il vaut mieux acheter tout de suite.',
      cl_autoRenew_title: 'Pro en renouvellement automatique',
      cl_autoRenew_desc: 'CHF 5.90 le premier mois, puis CHF 5.40 par mois : plus besoin de réactiver à la main, résiliable à tout moment en un clic.',
      cl_priceAccuracy_title: 'Des prix et des alertes plus justes',
      cl_priceAccuracy_desc: 'Nous avons corrigé une cause de fausses baisses de prix, et les alertes n\'arrivent plus que pour les annonces où vous les avez vous-même activées.',
      cl_photoSearch_title: 'Rechercher avec une photo',
      cl_photoSearch_desc: 'Nouveau : icône appareil photo dans la barre de recherche. Photographiez un objet ou envoyez une image — nous identifions le produit, la marque et le modèle, puis affichons les annonces correspondantes sur tous les marketplaces. La photo est seulement analysée puis immédiatement supprimée, jamais conservée.',
      cl_typoFix_title: 'Les fautes de frappe sont corrigées automatiquement',
      cl_typoFix_desc: 'En tapant « plastation 5 » ou « iphon 15 », vous obtenez directement les bons résultats, avec la mention du terme réellement recherché. Avant, il n\'y avait qu\'une suggestion à cliquer.',
      cl_synonyms_title: 'Vélo, bici, Fahrrad — une recherche, toutes les langues',
      cl_synonyms_desc: 'Environ 60 nouveaux groupes de synonymes avec de vrais helvétismes : vélo, Töff, Töffli, Natel, trottinette, Finken… Cherchez dans votre langue et trouvez les annonces dans les quatre langues, pluriels et accents inclus.',
      cl_relevance_title: 'Résultats de recherche beaucoup plus précis',
      cl_relevance_desc: 'Avant, « PlayStation 5 » ramenait aussi des appartements 5.5 pièces ou des chaussures taille 45. Désormais tous les mots doivent correspondre, les chiffres appartiennent au modèle (« iPhone 5 » ≠ « iPhone 15 ») et le titre compte plus que la description.',
      cl_contentFilter_title: 'Plus d\'annonces érotiques ni de services',
      cl_contentFilter_desc: 'Les annonces de massages érotiques et d\'accompagnement, ainsi que les rubriques services et emplois des marketplaces, sont filtrées — les produits comme les pistolets de massage ou les fauteuils massants restent bien sûr disponibles.',
      cl_dealsDedupe_title: 'Meilleures affaires sans doublons',
      cl_dealsDedupe_desc: 'Les annonces quasi identiques d\'un même vendeur n\'apparaissent plus qu\'une fois, de même que celles publiées à la fois sur Tutti et Anibis. Plus de variété par page.',
      cl_moreListings_title: 'Beaucoup plus d\'annonces de Tutti et Anibis',
      cl_moreListings_desc: 'Après un changement technique, nous lisons environ 20x plus d\'annonces par passage sur Tutti.ch et Anibis.ch — les nouvelles offres arrivent plus vite et plus complètes.',
      cl_infiniteScroll_title: 'Défilement infini sur les pages d\'annonces',
      cl_infiniteScroll_desc: 'Sur Meilleures Affaires, Nouveautés, Enchères et Résultats de recherche, les annonces se chargent automatiquement en faisant défiler — plus besoin de cliquer sur page 2, 3, 4…',
      cl_dealsNewestFix_title: 'Meilleures Affaires et Accueil : tri et mix corrects',
      cl_dealsNewestFix_desc: 'La page Meilleures Affaires s\'ouvre désormais sur les annonces les plus récentes par défaut. Section « Dernières annonces » de l\'accueil : équilibrée entre Tutti, Anibis, Ricardo, Shpock et eBay au lieu d\'un seul marketplace.',
      cl_howItWorks_title: 'Nouvelle page « Comment ça marche »',
      cl_howItWorks_desc: 'Une page simple qui explique en 4 étapes comment ScanMarket agrège les annonces des 5 marketplaces suisses. Pratique à partager avec ceux qui ne nous connaissent pas encore.',
      cl_seoSsr_title: 'Vraie SEO — annonces visibles sur Google',
      cl_seoSsr_desc: 'ScanMarket apparaît maintenant dans les résultats Google avec les bons titres et images. Les aperçus WhatsApp et Telegram montrent aussi la photo du produit et le prix quand tu partages un lien.',
      cl_categoryPages_title: 'Pages catégorie dédiées',
      cl_categoryPages_desc: 'Chaque catégorie a maintenant sa propre page (ex. /c/furniture) avec toutes les annonces, stats et catégories liées — clique sur une catégorie en home pour y aller directement.',
      cl_subcategories_title: 'Filtre sous-catégories',
      cl_subcategories_desc: 'Sur chaque page catégorie tu trouves rapidement les sous-catégories (ex. dans Meubles : canapés, chaises, tables). Seules les sous-cats avec au moins 15 annonces sont affichées — moins de bruit.',
      cl_newCats_title: '7 nouvelles catégories',
      cl_newCats_desc: 'Immobilier, Bébé & Enfants, Animaux, Antiquités & Art, Collection, Billets & Bons, Bateaux — avant cachés sous "Autre", maintenant cherchables indépendamment.',
      cl_sharePreview_title: 'Meilleurs aperçus de lien',
      cl_sharePreview_desc: 'Quand tu partages un lien annonce sur WhatsApp, Telegram, Twitter ou Facebook, tu vois maintenant la vraie photo produit et le prix — plus seulement le logo ScanMarket.',
      cl_anibisCats_title: 'Anibis : catégorisation correcte',
      cl_anibisCats_desc: 'Les annonces Anibis étaient parfois mal catégorisées (ex. sous "Autre" au lieu de "Meubles"). Maintenant correct — merci à ceux qui ont signalé.',
      cl_aiDeal_desc: 'Notre IA vérifie chaque top affaire et détecte défauts cachés, titres trompeurs ou contrefaçons. Tu vois seulement les vraies bonnes affaires, avec une courte explication.',
      cl_privacy_title: 'Transparence & Confidentialité (LPD/RGPD)',
      cl_privacy_desc: 'Paramètres cookies entièrement personnalisables. Les IP sont toujours anonymisées. Les données anonymes sont supprimées après 24 mois.',
      cl_nightMode_title: 'Mise à jour plus rapide des annonces',
      cl_nightMode_desc: 'Nous optimisons le scraping des marketplaces pour des résultats plus rapides le matin, quand tu cherches de nouvelles affaires.',
      cl_proUpsell_title: 'Suggestions Pro plus intelligentes',
      cl_proUpsell_desc: 'Les fonctionnalités Pro s\'affichent exactement quand tu en as besoin — fini les bannières inutiles.',
      cl_homepage_title: 'Nouvelle page d\'accueil avec plus d\'offres',
      cl_homepage_desc: 'Les meilleures offres sont maintenant en haut, en pleine largeur, avec 16 annonces — trouve plus vite ce que tu cherches.',
      cl_ghostAuction_title: 'Enchères expirées masquées',
      cl_ghostAuction_desc: 'Bug corrigé : les enchères Ricardo restaient parfois visibles après expiration. Elles sont maintenant retirées automatiquement.',
      cookieTitle: 'Nous respectons votre vie privée',
      cookieDesc: 'Nous utilisons des cookies analytiques anonymes pour améliorer ScanMarket. Nous ne partageons jamais vos données.',
      cookiePrivacyLink: 'Lire la politique de confidentialité',
      cookieLegalNote: 'Conforme LPD et RGPD — les IP sont toujours anonymisées.',
      cookieAcceptBtn: 'Tout accepter',
      cookieRejectBtn: 'Refuser',
      cookieSettingsLink: 'Préférences cookies',
      cookieCurrentStatus: 'Statut actuel',
      privacyTitle: 'Politique de confidentialité',
      privacyLastUpdated: 'Dernière mise à jour',
      privacyDate: 'avril',
      privacyIntro: 'ScanMarket.ch respecte votre vie privée et se conforme à la Loi suisse sur la protection des données (LPD) et au RGPD européen. Cette politique décrit les données que nous collectons et pourquoi.',
      privacyDataWeCollect: 'Données que nous collectons',
      privacyDataPageviews: 'Vues de pages anonymisées (IP masquée sur /24, pas d\'empreinte navigateur sans consentement).',
      privacyDataAccount: 'Informations de compte lors de l\'inscription (email, nom) — uniquement avec votre consentement.',
      privacyDataSaved: 'Vos annonces sauvegardées et préférences de notification, uniquement lorsque vous êtes connecté.',
      privacyDataPayments: 'Les informations de paiement sont gérées exclusivement par Stripe — nous ne stockons aucune donnée de carte.',
      privacyCookiesTitle: 'Cookies',
      privacyCookiesDesc: 'Nous utilisons un nombre minimal de cookies. Les cookies analytiques sont activés uniquement si vous acceptez.',
      privacyColName: 'Nom',
      privacyColPurpose: 'Finalité',
      privacyColRetention: 'Rétention',
      privacyCookieSession: 'ID de session pour navigation anonyme',
      privacyCookieConsent: 'Stocke votre choix de cookies',
      privacyCookieLang: 'Votre préférence de langue',
      privacyCookiePosthog: 'Analytiques anonymes (uniquement après consentement)',
      privacyRetSession: 'Session',
      privacyRet60m: '60 mois',
      privacyRet12m: '12 mois',
      privacyCookiesChange: 'Vous pouvez modifier vos préférences à tout moment',
      privacyRightsTitle: 'Vos droits',
      privacyRightsDesc: 'Conformément au RGPD et à la LPD, vous avez les droits suivants :',
      privacyRightAccess: 'Accès à vos données personnelles',
      privacyRightErase: 'Effacement de vos données ("droit à l\'oubli")',
      privacyRightPortability: 'Portabilité des données',
      privacyRightObject: 'Opposition au traitement',
      privacyContactTitle: 'Contact',
      privacyContactDesc: 'Pour toute question relative à la confidentialité, écrivez à',
      privacyLegalBasis: 'Base légale : Loi fédérale suisse sur la protection des données (LPD), RGPD art. 6(1)(a) consentement et 6(1)(f) intérêt légitime pour les agrégats anonymes.',
      footerDataFrom: 'Données de',
      condNew: 'Neuf', condLikeNew: 'Comme neuf', condGood: 'Bon état', condFair: 'État correct', condBroken: 'Défectueux',
      description: 'Description', translated: 'traduit', original: 'Original', translateTo: 'Traduire en',
      detailsSection: 'Détails', positionLabel: 'Lieu', postalCode: 'Code postal', publishedAt: 'Publié', detectedAt: 'détecté le',
      conditionLabel: 'État', brandLabel: 'Marque', saleTypeLabel: 'Type de vente', categoryLabel: 'Catégorie',
      priceHistory: 'Historique des prix', priceStable: 'Stable', fromFirstRecord: 'depuis le premier enregistrement',
      minLabel: 'Min', maxLabel: 'Max', priceRecordedOn: 'Prix enregistré le',
      priceGraphSoon: 'Le graphique apparaîtra avec plus d\'enregistrements.', priceCheckedOnOpen: 'Le prix est vérifié à chaque ouverture.', priceHistoryCollecting: 'Historique en cours...', priceHistoryProTitle: 'Alertes prix & historique — Pro', priceHistoryProDesc: 'Recevez des notifications en cas de baisse de prix et pour les nouvelles annonces. Historique des prix inclus.', discoverPro: 'Découvrir Pro', datePosted: 'Publié sur le site original', dateScraped: 'Dernière capture par ScanMarket', aiDisclaimer: 'Analyse automatique — vérifiez toujours avant l\'achat.', aiBadgeTitle: 'Analyse IA', aiBadgeAria: 'Explication IA — touchez pour voir le texte complet',
      openOn: 'Ouvrir sur', goToListingOn: 'Aller à l\'annonce sur',
      auctionPageTitle: 'Enchères en Cours', auctionPageSubtitle: 'Ricardo.ch — Prix mis à jour toutes les 2 heures',
      allAuctionsTab: 'Toutes les Enchères', premiumAuctionsTab: '🏆 Enchères Premium',
      priceRangeLabel: 'Plage de prix', allPrices: 'Tous', extraFilters: 'Filtres supplémentaires',
      filtersLabel: 'Filtres', applyFilters: 'Appliquer', resetFilters: 'Réinitialiser',
      premiumOnly: 'Premium uniquement (>CHF 500)', removePremiumFilter: 'Supprimer filtre Premium',
      premiumAuctionsTitle: 'Enchères Premium', premiumAuctionsSubtitle: 'Offre actuelle > CHF 500',
      noAuctionsPremium: 'Aucune enchère premium', auctionsCount: 'enchères', noAuctions: 'Aucune enchère trouvée', removeFilters: 'Supprimer les filtres',
      createAlertTitle: '🔔 Créer une alerte', notificationsFor: 'Notifications pour', enterAtLeastOne: 'Entrez au moins une méthode de notification',
      telegramChatId: 'Telegram Chat ID', telegramIdHint: 'Écrivez /start à @ScanMarketChBot pour obtenir votre ID',
      activating: 'Création...', activateNotifications: '🔔 Activer les notifications',
      stayUpdated: '🔔 Restez informé', alertBannerText: 'Souhaitez-vous être alerté quand de nouveaux', alertBannerText2: 'apparaissent?',
      activateFreeAlert: 'Activer alerte Pro',
      proTitle: 'ScanMarket Pro', proUpgradeCta: '🚀 Activer Pro — CHF 9.90/mois', proStripNote: 'Paiement sécurisé via Stripe · Résiliable à tout moment',
      proBenefitAlerts: 'Notifications email et Telegram', proBenefitUnlimited: 'Jusqu\'à 3 alertes actives', proBenefitHistory: 'Historique des prix et deal score',
      promote: '⭐ Promouvoir',
      featuredTitle: 'Mettre votre annonce en avant',
      featuredSubtitle: 'Vous avez déjà une annonce sur Tutti.ch, Ricardo.ch, Anibis.ch ou Shpock? Montrez-la à tous les visiteurs de ScanMarket.',
      featuredHow: 'Comment ça marche',
      featuredStep1: 'Collez le lien de votre annonce existante',
      featuredStep2: 'Vérifiez l\'aperçu automatique',
      featuredStep3: 'Choisissez un niveau (CHF 4.90 / 8.90 / 14.90) et payez — badge, position et accueil selon le niveau',
      featuredProNote: '1er abonnement Pro : 1 mise en avant offerte — Base (CHF 4.90) en mensuel, Standard (CHF 8.90) en annuel',
      featuredUrlLabel: 'URL de votre annonce *',
      featuredLoadPreview: 'Charger l\'aperçu',
      featuredSupported: 'Supportés: Tutti.ch, Anibis.ch, Ricardo.ch, Shpock, eBay.ch',
      featuredPreviewLabel: 'Aperçu de l\'annonce:',
      featuredProduct: 'Mise en avant',
      featuredBenefit1: '✅ Badge "En avant" sur 5 pages: Accueil, Deals, Nouveautes, Encheres, Resultats',
      featuredBenefit2: '✅ Toujours en haut — visible avant toutes les annonces normales',
      featuredBenefit3: '✅ 10 jours, des milliers d\'acheteurs potentiels par jour',
      featuredPayCta: '⭐ Payer et mettre en avant',
      featuredStripeNote: 'Paiement sécurisé via Stripe',
      featuredSuccessTitle: 'Annonce mise en avant! 🎉', featuredSuccessText: 'Votre annonce apparaît en tête des résultats pendant 10 jours.',
      featuredSuccessWhat: '✅ Ce qui se passe maintenant:', featuredSuccessBadge: '⭐ Badge "En avant" sur votre annonce', featuredSuccessTop: '🔝 En tête des recherches pertinentes', featuredSuccessHome: '👥 Visible sur la page d\'accueil ScanMarket',
      featuredBackHome: 'Retour à l\'accueil →',
      featuredCheckingPayment: 'Vérification du paiement...', featuredWait: 'Veuillez patienter quelques secondes',
      featuredPaymentFailed: 'Paiement échoué', featuredRetry: 'Réessayer',
      loading: 'Chargement...',
      error: 'Erreur',
      retry: 'Réessayer',
      chf: 'CHF',
      free: 'Gratuit',
      recentlyViewed: 'Vus récemment', recentlyViewedNewBadge: 'nouveau',
      clearAll: 'Tout supprimer',
      confirmClearAll: 'Confirmer ?',
      forYou: 'Pour vous',
      whatIsItWorth: 'Quelle valeur ?',
      whatIsItWorthShort: 'Valeur',
      menuGroupDiscover: 'Découvrir',
      menuGroupMine: 'Mon compte',
      menuGroupSettings: 'Paramètres',
      checkingAvailability: 'Vérification de la disponibilité...',
      listingUnavailable: 'Cette annonce pourrait ne plus être disponible',
      availabilityWarning: 'La disponibilité n\'a pas pu être vérifiée — vérifiez sur le site d\'origine',
      loadingPhotos: 'Chargement des photos...',
      galleryTitle: 'Photos', galleryClose: 'Fermer', galleryPrev: 'Photo précédente', galleryNext: 'Photo suivante', galleryOpen: 'Voir les photos en plein écran',
      saveListing: 'Enregistrer',
      savedListing: 'Enregistré',
      removedFromSaved: 'Retiré des favoris',
      listingSaved: 'Annonce enregistrée !',
      limitReached: 'Limite atteinte — passez à Pro',
      avgPriceForSimilar: 'Prix moyen pour des articles similaires',
      yearContextLabel: 'Année du modèle',
      yearContextText: 'C\'est un {{year}} : les {{year}} sont à CHF {{median}}, les {{latestYear}} à CHF {{latestMedian}}.',
      belowAverage: 'en dessous de la moyenne',
      aboveAverage: 'au-dessus de la moyenne',
      basedOnComparables: 'Basé sur {{count}} annonces similaires dans la base de données',
      priceWatchTitle: 'M\'alerter si le prix baisse',
      priceWatchNotify: 'M\'alerter',
      priceWatchSet: 'Nous vous alerterons quand le prix descendra sous CHF {{price}}',
      invalidPrice: 'Veuillez entrer un prix valide',
      priceWatchError: 'Erreur lors de la création de l\'alerte',
      similarListings: 'Pourrait aussi vous intéresser',
      reportSent: 'Signalement envoyé',
      reportUnavailable: 'Signaler l\'annonce comme indisponible',
      loginToReport: 'Connectez-vous pour signaler une annonce',
      signIn: 'Se connecter',
      alreadyReported: 'Vous avez déjà signalé cette annonce',
      thanksReport: 'Merci pour le signalement !',
      reportError: 'Erreur lors du signalement',
      linkCopied: 'Lien copié !',
      copyFailed: 'Impossible de copier le lien',
      emailOptional: 'E-mail (optionnel)',
      scrapingBanner: 'Mise à jour des annonces en cours — nouveaux résultats dans quelques secondes...',
      pushBannerTitle: 'Restez informé',
      pushBannerDesc: 'Recevez des notifications instantanées lorsque nous trouvons des offres exceptionnelles pour vos recherches.',
      pushBannerActivate: 'Activer les notifications',
      pushBannerActivating: 'Activation...',
      pushBannerDismiss: 'Pas maintenant',
      pushSuccess: 'Notifications activées !',
      pushErrorGeneric: 'Impossible d\'activer les notifications',
      pushErrorDenied: 'Autorisation refusée par le navigateur. Vérifiez les paramètres du site.',
      pushErrorUnsupported: 'Votre navigateur ne prend pas en charge les notifications push',
      featuredLabel: 'En vedette',
      loginTitle: 'Se connecter',
      registerTitle: 'Créer un compte',
      forgotTitle: 'Mot de passe oublié',
      continueGoogle: 'Continuer avec Google',
      googleDesc: 'Aucun mot de passe à retenir. Connexion sécurisée avec votre compte Google.',
      loginSubmitBtn: 'Se connecter',
      forgotLink: 'Mot de passe oublié ?',
      registerLink: "S'inscrire →",
      namePlaceholder: 'Votre nom',
      passPlaceholder: 'Mot de passe (min. 8 caractères)',
      passConfirmPlaceholder: 'Confirmer le mot de passe',
      createAccountBtn: 'Créer un compte',
      haveAccount: 'Déjà un compte ?',
      forgotDesc: 'Entrez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
      resetSubmitBtn: 'Envoyer l\'e-mail',
      backToLogin: '← Retour à la connexion',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Mot de passe minimum 8 caractères',
      welcomeUser: 'Bienvenue, {{name}} !',
      welcomeBack: 'Bon retour, {{name}} !',
      welcomeNew: 'Bienvenue sur ScanMarket, {{name}} !',
      resetSent: 'E-mail envoyé à {{email}} — vérifiez votre boîte de réception',
      googleError: 'Connexion Google annulée ou échouée',
      connectionError: 'Erreur de connexion. Veuillez réessayer.',
      nudgeTitle: 'Suivez les offres',
      nudgeDesc: 'Sauvegardez des annonces et recevez des alertes sur les meilleures offres.',
      nudgeDismiss: 'Plus tard',
      reportBtn: 'Signaler',
      reportBtnDone: 'Signalé',
      unavailableShort: 'Plus disponible',
      radarOff: 'Radar désactivé pour "{{keyword}}"',
      radarOn: 'Radar actif pour "{{keyword}}" — vous recevrez des notifications pour des annonces similaires',
      limitSavedPro: 'Limite atteinte — passez à Pro pour des annonces illimitées',
      limitAlertPro: 'Les alertes sont une fonction Pro — passez à Pro pour recevoir des notifications email sur vos bonnes affaires préférées',
      proUpsellAlertTitle: 'Ne ratez plus aucune affaire',
      proUpsellAlertDesc: 'Avec Pro, recevez des alertes email automatiques dès qu\'une annonce correspond à vos mots-clés.',
      proUpsellSavedTitle: 'Enregistrez autant d\'annonces que vous voulez',
      proUpsellSavedDesc: 'Avec Pro, aucune limite d\'enregistrement : retrouvez toujours vos favoris.',
      proUpsellCompareTitle: 'Comparez les annonces côte à côte',
      proUpsellCompareDesc: 'Avec Pro, mettez plusieurs annonces côte à côte et faites le meilleur choix.',
      proUpsellAnalyticsTitle: 'Analyses de prix détaillées',
      proUpsellAnalyticsDesc: 'Avec Pro, voyez l\'historique des prix, la médiane et les statistiques de marché pour chaque recherche.',
      proUpsellPriceHistoryTitle: 'Historique des prix en détail',
      proUpsellPriceHistoryDesc: 'Avec Pro, voyez comment le prix de chaque annonce a évolué dans le temps.',
      proUpsellBenefitUnlimited: 'Sauvegardes illimitées',
      proUpsellBenefitAlerts: 'Alertes email pour nouvelles annonces et baisses de prix',
      proUpsellBenefitPriceHistory: 'Historique des prix et tendances',
      proUpsellBenefitNoAds: 'Sans pub, support prioritaire',
      proUpsellForYou: '↑ pour toi',
      proUpsellCta: 'Découvrir Pro',
      proUpsellLater: 'Pas maintenant',
      compareSelected: 'sélectionnés',
      compareReady: 'Prêt à comparer',
      compareNeedMore: 'Choisissez 2+ annonces',
      compareCta: 'Comparer',
      compareClear: 'Vider la sélection',
      compareTitle: 'Comparaison d\'annonces',
      compareField: 'Champ',
      compareBestPrice: '(meilleur prix)',
      compareEnableHint: 'Sélectionnez des annonces pour comparer',
      compareModeOn: 'Arrêter la comparaison',
      compareModeOff: 'Comparer (Pro)',
      openedOnSource: 'Ouvert sur {{source}}',
      scanmarketHere: 'ScanMarket reste ici pour vous',
      fromYou: 'de vous',
      verifiedDealTooltip: 'Comparé avec {{count}}+ produits similaires à prix homogènes. Haute fiabilité.',
      uncertainDealTooltip: 'Les prix comparables varient — vérifiez sur le marketplace.',
      medianTooltip: 'Valeur médiane des annonces similaires dans la base de données',
      dealCalcTooltip: 'Comment calculons-nous la valeur estimée ?',
      dealCalcDesc: 'Nous comparons le prix avec des annonces similaires par titre et catégorie.',
      estValueLabel: 'Valeur estimée',
      verifyAvailability: 'Vérifier la disponibilité',
      aboutDaysAgo: '~{{days}}j',
      loginToReportToast: 'Connectez-vous pour signaler une annonce',
      reportAlreadyDone: 'Vous avez déjà signalé cette annonce',
      reportThanks: 'Merci pour le signalement !',
      reportErrorToast: 'Erreur lors du signalement',
      close: 'Fermer',
    }
  },
  it: {
    translation: {
      home: 'Cerca',
      deals: 'Migliori Offerte',
      newest: 'Recenti',
      saved: 'Salvati',
      auctions: 'Aste',
      login: 'Accedi',
      proActiveMenu: 'Pro attivo',
      proUpgradeMenu: 'Passa a Pro',

      signupOrLogin: 'Registrati / Accedi',
      logout: 'Esci',
      settings: 'Impostazioni',
      heroTitle: 'Trova i migliori affari\nin Svizzera',
      heroSubtitle: 'ScanMarket è un aggregatore che ti permette di cercare contemporaneamente su Ricardo, Tutti, Anibis, Shpock ed eBay Svizzera.',
      heroTagline: 'Trova l\'affare prima degli altri.',
      liveUpdateBadge: 'Live · annunci aggiornati in tempo reale',
      headerLiveText: 'in aggiornamento',
      heroSearchBtn: 'Cerca',
      listingsCount: 'annunci',
      apiDownMsg: 'Il servizio è momentaneamente non raggiungibile. Ci stiamo lavorando — riprova tra un istante.',
      apiDownRetry: 'Riprova',
      similarResultsTitle: 'Risultati simili',
      similarResultsHint: 'senza indicazione elettrica, per «{q}»',
      correctedNoticePrefix: 'Risultati per',
      correctedNoticeSuffix: 'cerca invece',
      imageSearchTitle: 'Cerca con una foto',
      imageSearchAnalyzing: 'Analisi della foto…',
      imageSearchFound: 'Riconosciuto',
      imageSearchNotRecognized: 'Oggetto non riconosciuto — prova con un\'altra foto',
      imageSearchFormatError: 'Solo JPG, PNG o WEBP',
      imageSearchTooLarge: 'Foto troppo grande (max 6 MB)',
      imageSearchError: 'Ricerca per foto non riuscita',
      photoSearchCardTitle: 'Cerca con una foto',
      photoSearchCardDesc: 'Scatta o trascina una foto — troviamo l\'oggetto su tutti i marketplace.',
      photoSearchCardCta: 'Scegli foto',
      photoSearchCardBadge: 'Novità',
      copyFilterLink: 'Copia link',
      photoSearchLoginRequired: 'Accedi per cercare con una foto',
      shareOnWhatsapp: 'Condividi su WhatsApp',
      shareOnTelegram: 'Condividi su Telegram',
      cl_priceArchive_title: 'Prezzo di mercato con finestra per categoria',
      cl_priceArchive_desc: "Lo sconto delle Migliori Offerte ora si confronta anche con annunci già venduti o scaduti, con una finestra per categoria: 90 giorni per l'elettronica, fino a 6 mesi per i veicoli, fino a 12 mesi per strumenti musicali, attrezzi e orologi, la stessa stagione dell'anno prima per bici e articoli sportivi stagionali. La finestra si allarga solo se ci sono meno di 20 annunci simili, e in quel caso lo vedi nell'annuncio.",
      cl_specSearch_title: 'Ricerca più precisa per misure e obiettivi',
      cl_specSearch_desc: "«Sony 12 - 24mm», «12–24 mm» o «f2.8» ora vengono capiti come «12-24mm» e «F/2,8»: trovi l'obiettivo comunque sia scritto. E la ricerca resta veloce anche per le richieste più rare.",
      cl_dealsFast_title: 'Migliori Offerte più veloci e più pulite',
      cl_dealsFast_desc: 'Le Migliori Offerte si aprono molto più in fretta e non mostrano più case, animali o scarpe usate: solo oggetti davvero confrontabili con il prezzo di mercato.',
      cl_noReload_title: 'Niente più ricaricamenti quando torni',
      cl_noReload_desc: "Se durante una ricerca apri un annuncio sul sito d'origine e poi torni indietro, la pagina non si ricarica più e la ricerca non riparte da capo: continua semplicemente.",
      cl_gallery_title: "Foto a tutto schermo, come in un'app",
      cl_gallery_desc: "Tocca la foto di un annuncio: scorri tra le immagini con il dito, ingrandisci con due dita o doppio tocco e trascina in giù per chiudere. In basso trovi tutte le miniature.",
      cl_back_title: "Il tasto «indietro» torna ai risultati",
      cl_back_desc: "Sul telefono (tasto indietro o swipe su iPhone) mentre guardi un annuncio ora torni ai risultati, non più alla home.",
      cl_centerView_title: "Annuncio al centro dello schermo",
      cl_centerView_desc: "Sul computer l'annuncio si apre al centro, in una finestra più grande, invece che sul lato destro.",
      cl_autoScroll_title: "Più annunci in automatico",
      cl_autoScroll_desc: "Arrivato in fondo alla pagina, i nuovi annunci si caricano da soli: niente più pulsante «Carica altri».",
      cl_typoCategory_title: "Parole sbagliate: categoria giusta",
      cl_typoCategory_desc: "Se scrivi «ipune» o «mercedesschwarz», correggiamo la parola e mettiamo la categoria che avrebbe la parola giusta (Smartphone, Auto…). E la ricerca è più veloce.",
      cl_yearSearch_title: "Ricerca con l'anno",
      cl_yearSearch_desc: "«iMac 2019» o «Golf 2015» ora trovano anche i titoli con altre parole in mezzo, come «iMac 27\" Retina 5K 2019».",
      cl_auctionReminder_title: "Avviso 1 ora prima della fine dell'asta (Pro)",
      cl_auctionReminder_desc: "Tocca ⏰ su un'asta oppure salvala: circa 1 ora prima della fine ti arriva un messaggio su Telegram e/o per email, con foto, offerta attuale e prezzo Compralo subito. Scegli il canale nella pagina Salvati.",
      cl_ricardoPrices_title: "Aste Ricardo: prezzi corretti",
      cl_ricardoPrices_desc: "Su alcune aste Ricardo compariva il prezzo di un annuncio simile. Ora offerta attuale e Compralo subito vengono letti solo dall'asta stessa.",
      cl_shareOne_title: "Un solo pulsante «Condividi»",
      cl_shareOne_desc: "WhatsApp, Telegram e Copia link ora sono in un unico pulsante «Condividi»: più spazio sopra i risultati.",
      cl_compactResults_title: "Risultati più compatti su mobile",
      cl_compactResults_desc: "Meno spazio prima del primo annuncio: categorie e ricerche correlate in una sola riga, tutti i pulsanti in fila, e la barra in alto non viene più tagliata.",
      shareSearch: 'Condividi',
      shareMoreApps: 'Altre app…',
      medianShort: 'Mediana',
      cl_photoWidget_title: 'Ricerca per foto in evidenza',
      cl_photoWidget_desc: 'Nuovo riquadro sotto la barra di ricerca: scatta o trascina una foto e vedi subito gli annunci corrispondenti.',
      cl_newPricing_title: 'Nuovi piani Pro: mensile o annuale',
      cl_newPricing_desc: 'Pro a CHF 9.90 al mese oppure CHF 99 all\'anno (due mesi gratis). Al primo abbonamento ricevi un annuncio in evidenza omaggio. Chi era già abbonato mantiene il suo vecchio prezzo.',
      cl_telegramOneTap_title: 'Alert Telegram con un tocco',
      cl_telegramOneTap_desc: 'Niente più Chat ID da copiare: premi "Collega Telegram", tocca Avvia nel bot e sei collegato. Ricevi i 3 annunci migliori con foto e un riepilogo degli altri, senza intasare la chat. Funzione Pro.',
      cl_alertPrice_title: 'Alert con prezzo massimo e i tuoi filtri',
      cl_alertPreview_title: 'Anteprima quando crei un avviso',
      cl_alertPreview_desc: 'Mentre crei un avviso vedi subito quanti annunci corrispondono oggi e quanti ne sono arrivati negli ultimi 7 giorni. Se non corrisponde niente, ti suggeriamo di usare parole più semplici.',
      cl_tgVolume_title: "Telegram: scegli quanti affari ricevere",
      cl_tgVolume_desc: "Nelle migliori offerte su Telegram ora scegli Pochi (3 alla volta), Tanti (10) o Tutti. Quelli oltre il limite arrivano in un messaggio «+N altri affari» con il link alla lista completa: nessun affare va perso.",
      cl_tgDeals_title: "Migliori offerte su Telegram (Pro)",
      cl_tgDeals_desc: "I nuovi affari direttamente in chat Telegram: foto, prezzo, sconto e pulsante per contattare il venditore. Scegli categorie, sconto minimo e prezzo massimo in «I miei alert».",
      cl_fastAlerts_title: "Alert ogni 10 minuti",
      cl_fastAlerts_desc: "Gli alert Pro ora vengono controllati ogni 10 minuti e possono avvisarti ogni 30 minuti. Le ricerche dei Pro riscaricano i marketplace ogni 30 minuti.",
      cl_carSpecs_title: "Auto: anno e chilometri",
      cl_carSpecs_desc: "Sulle schede di auto e moto vedi anno di immatricolazione e chilometri. Il filtro anno ignora date come «ultimo tagliando 2023».",
      cl_newOnTop_title: "Nuovi annunci sempre in alto",
      cl_newOnTop_desc: "Se resti sulla pagina dei risultati, i nuovi annunci compaiono in alto con l'avviso «nuovi annunci» — mai più in fondo alla lista.",
      cl_autocomplete_title: 'Suggerimenti mentre scrivi',
      cl_autocomplete_desc: 'Mentre scrivi ti proponiamo le ricerche più popolari e le tue ultime ricerche, con accanto la categoria giusta (es. «iphone 13 in Smartphone»). Tocca il campo vuoto per vedere cosa va di tendenza adesso.',
      cl_instantSearch_title: 'Ricerca istantanea',
      cl_instantSearch_desc: 'I risultati ora compaiono quasi all\'istante, anche per le parole con sinonimi («divano», «velo») e per le ricerche di due parole. E quando tante persone cercano nello stesso momento, il sito resta fluido.',
      cl_newListingsPill_title: 'Nuovi annunci senza interruzioni',
      cl_newListingsPill_desc: 'Mentre Vulpi cerca nuovi annunci sui marketplace, la tua lista resta ferma. Se trova qualcosa, in alto compare «X nuovi annunci»: basta un tocco per vederli, evidenziati.',
      cl_alertSuggest_title: 'Suggerimento per le parole attaccate',
      cl_alertSuggest_desc: 'Se scrivi «iPhone 12mini» o «golf7», con un tocco ti proponiamo la versione giusta («12 mini», «golf 7»), così non ti perdi nessun annuncio.',
      cl_smartSearch_title: 'Ricerca più tollerante',
      cl_smartSearch_desc: 'La ricerca ora capisce anche le parole attaccate: «golf7» dà gli stessi risultati di «golf 7». E «Apple iPhone» trova anche gli annunci in cui c\'è scritto solo «iPhone».',
      cl_preciseAlerts_title: 'Avvisi più precisi',
      cl_preciseAlerts_desc: 'Gli avvisi considerano solo le parole intere: un avviso per «Kare» non segnala più una «Schubkarre». E un avviso «iPhone 12mini» ora trova anche gli annunci scritti «12 mini». Vale per tutti gli avvisi già attivi.',
      cl_vulpi_title: 'Vi presentiamo Vulpi!',
      cl_vulpi_desc: 'ScanMarket ha una mascotte: Vulpi, una volpe che fiuta gli affari per te. La incontri quando una ricerca non trova niente, tra i tuoi annunci salvati e i tuoi avvisi, nella pagina Pro e in una nuova pagina di errore quando un indirizzo non esiste o un annuncio è stato venduto.',
      cl_newLogo_title: 'Nuovo logo',
      cl_newLogo_desc: 'Il logo ora è la testa di Vulpi con la lente rosso svizzero, ben visibile anche in modalità scura. La volpe è anche la nuova icona nella scheda del browser e sulla schermata del telefono.',
      cl_vulpiAlerts_title: 'Gli avvisi firmati Vulpi',
      cl_vulpiAlerts_desc: 'Le email degli avvisi e i messaggi Telegram ora arrivano da Vulpi: «Ho fiutato 3 nuovi annunci per te!». Anche il nostro bot Telegram ha una nuova foto profilo.',
      cl_loginFox_title: 'La volpe all\'accesso',
      cl_loginFox_desc: 'Quando accedi o ti registri, Vulpi segue il mouse con gli occhi, ti guarda mentre scrivi e si copre gli occhi quando inserisci la password.',
      cl_smartBar_title: 'La barra di ricerca che ti segue',
      cl_smartBar_desc: 'Quando scorri verso il basso la barra in alto sparisce e lascia più spazio agli annunci. Appena risali un po\' ricompare subito, pronta per una nuova ricerca.',
      cl_photoIcon_title: 'Ricerca con foto nella barra',
      cl_photoIcon_desc: 'La ricerca con una foto ora è un\'icona della fotocamera direttamente nella barra di ricerca della home: un tocco e carichi un\'immagine.',
      cl_stickyFilters_title: 'I filtri restano a portata',
      cl_stickyFilters_desc: 'Su computer la colonna dei filtri ora resta ferma mentre scorri la pagina, così puoi affinare la ricerca senza tornare in cima.',
      cl_yearValue_title: 'Curva del valore per anno',
      cl_yearValue_desc: 'Nella pagina Valore ora c\'è una curva semplice che mostra quanto vale un modello anno per anno. E dentro ogni annuncio trovi il confronto diretto, per esempio "Questo è un 2017: i 2017 stanno a CHF 280, i 2019 a CHF 500".',
      cl_yearFilter_title: 'Filtro anno del modello',
      cl_yearFilter_desc: 'Nei filtri di ricerca puoi scegliere l\'annata e vedere solo gli annunci che dichiarano quell\'anno. Il link con il filtro è condivisibile.',
      cl_noFlatsDeals_title: 'Niente appartamenti nelle migliori offerte',
      cl_noFlatsDeals_desc: 'Appartamenti, case e terreni sono fuori dalle migliori offerte e dal calcolo dei prezzi: niente più "-54%" su un 1,5 locali. Gli oggetti veri, come una cyclette, restano al loro posto.',
      cl_telegramMode_title: 'Telegram: scegli tu cosa ricevere',
      cl_telegramMode_desc: 'Nel form dell\'avviso scegli subito tra "Solo affari top" e "Tutti gli annunci" — anche prima di collegare Telegram — e puoi cambiarlo su un avviso già creato. Nel messaggio c\'è il nuovo pulsante "Vedi tutti i N annunci" con i tuoi filtri.',
      cl_betterMedian_title: 'Prezzi medi più precisi',
      cl_betterMedian_desc: 'La media e la fascia di prezzo tipica ora confrontano solo lo stesso prodotto: niente giochi o accessori nella media di una PS5. Gli annunci difettosi vengono esclusi e, se ci sono troppi pochi annunci davvero confrontabili, preferiamo non mostrare nessun numero invece di uno sbagliato.',
      cl_betterCondition_title: 'Condizione più affidabile + descrizioni Ricardo',
      cl_betterCondition_desc: 'Molti meno falsi "Difettoso": la condizione viene riconosciuta con più prudenza e in tutte le lingue. Inoltre gli annunci Ricardo ora mostrano la descrizione completa.',
      cl_alertPrice_desc: 'Fatti avvisare solo se l\'annuncio rientra nella tua fascia di prezzo — e l\'alert prende anche marketplace, categoria e cantone della ricerca. Inoltre nessun annuncio nuovo va più perso, anche se ne escono 50 insieme.',
      cl_featuredTiers_title: 'Promuovi il tuo annuncio: 3 livelli',
      cl_featuredTiers_desc: 'Base CHF 4.90 per 3 giorni, Standard CHF 8.90 per 7 giorni con posizione più alta, Premium CHF 14.90 per 7 giorni anche in homepage.',
      cl_photoLogin_title: 'Ricerca con foto solo con account',
      cl_photoLogin_desc: 'Per evitare abusi, la ricerca con una foto ora richiede un account gratuito.',
      cl_shareFilters_title: 'Ricerche filtrate condivisibili',
      cl_shareFilters_desc: 'Prezzo, marketplace e ordinamento ora restano nell\'indirizzo: copi il link, lo condividi, e al ricaricamento ritrovi tutto come l\'avevi lasciato.',
      relaxedNoticePrefix: 'Nessun risultato esatto per',
      relaxedNoticeSuffix: 'mostriamo i risultati per',
      refreshLabel: 'Aggiorna',
      updatedLabel: 'Aggiornato',
      dealsFound: 'deals trovati',
      noListingsInPeriod: 'Nessun annuncio in questo periodo',
      marketplaceCount: 'marketplace',
      offersCount: 'offerte',
      nearbyTitle: '📍 Mostra offerte vicino a te',
      nearbyDesc: '— attiva la posizione per vedere la distanza da ogni annuncio',
      nearbyBtn: 'Attiva',
      distance: 'Distanza',
      bestDeals: 'Migliori Offerte',
      latestListings: 'Ultimi Annunci',
      auctionsTitle: 'Aste in Corso',
      auctionsPremiumLabel: 'Aste Premium (>CHF 500)',
      auctionsRegularLabel: 'Aste in Corso',
      discoverAllDeals: 'Scopri tutte le offerte',
      discoverAllListings: 'Scopri tutti gli annunci',
      discoverAllAuctions: 'Tutte le aste',
      discoverAllAuctionsPremium: 'Aste Premium',
      mpTuttiDesc: 'Il più grande marketplace svizzero',
      mpAnibisDesc: 'Romandia e oltre',
      mpRicardoDesc: 'Aste e prezzi fissi',
      mpShpockDesc: 'Mercatino online',
      mpEbayDesc: 'Aste e acquisti diretti',
      integrated: 'Integrato ✓',
      searchOnLabel: 'Cerca contemporaneamente su',
      trendingTitle: 'Ricerche del momento',
      suggestionPrefix: 'Forse cercavi', facetsLabelAll: 'Categorie', facetsLabelAlso: 'Anche in', countryConfirmTitle: 'Il tuo paese', countryConfirmBody: 'Ti mostriamo gli annunci di {{country}}. È corretto?', countryConfirmYes: 'Sì, continua', countryConfirmChange: 'Altro paese', categoryDroppedNotice: 'Nessun risultato in {{cat}} — mostriamo tutte le categorie', categoryInferredLabel: 'Categoria applicata automaticamente', categoryInferredRemove: 'Rimuovi', searchInCategory: 'Cerca in',
      relatedLabel: 'Ricerche correlate',
      browseCategories: 'Esplora per categoria',
      justPosted: 'APPENA PUBBLICATO',
      newArrival: 'Nuovo',
      auctionBadge: 'Asta in corso',
      currentBid: 'Offerta attuale',
      bids: 'offerte',
      endsIn: 'Scade tra',
      buyNowLabel: 'Compralo subito',
      verifiedDeal: 'Affare verificato',
      verifiedDealShort: 'VERIFICATO',
      uncertainDeal: 'Affare incerto',
      uncertainDealShort: 'DA VERIFICARE',
      priceTrend: 'Prezzo mediano',
      viewOffer: '🔥 Vedi offerta',
      details: 'Dettagli',
      open: 'Apri',
      save: 'Salva',
      saved2: 'Salvato',
      alertBtn: 'Avvisami',
      searchPlaceholder: 'MacBook, iPhone, PlayStation...',
      searchButton: 'Cerca',
      searchTitle: 'Trova occasioni di seconda mano in Svizzera',
      searchSubtitle: 'Tutti e Anibis in un\'unica ricerca',
      results: 'Risultati',
      resultsFor: 'risultati per',
      noResults: 'Nessun risultato trovato',
      noResultsHint: 'Prova altri termini o cerca direttamente sui marketplace',
      mascotNoResultsTitle: 'Niente per ora… ma non mi arrendo!',
      mascotNoResultsDesc: 'Crea un avviso e ti scrivo appena lo trovo.',
      mascotCreateAlert: 'Crea un avviso',
      alertSuggest: 'Forse intendevi',
      alertSuggestUse: 'Usa questa',
      alertPreviewLoading: 'Conto gli annunci che corrispondono…',
      alertPreviewCount: 'Oggi trovo {{count}} annunci che corrispondono',
      alertPreviewRecent: '{{count}} negli ultimi 7 giorni',
      alertPreviewNone: 'Al momento nessun annuncio corrisponde: prova parole più semplici.',
      mascotSavedEmpty: 'Qui è tutto tranquillo… salva un annuncio per svegliarmi!',
      mascotAlertsEmpty: 'Ancora nessun avviso. Creane uno e ti scrivo io appena arriva qualcosa di nuovo!',
      notFoundTitle: 'Ops… questa pagina non la trovo!',
      notFoundDesc: 'Ho fiutato dappertutto, ma questo indirizzo non esiste. Ripartiamo dalla home?',
      listingGoneTitle: 'Questo annuncio è sparito!',
      listingGoneDesc: 'Probabilmente è stato venduto o rimosso. Niente paura: ti aiuto io a trovarne uno simile.',
      goHomeBtn: 'Torna alla home',
      searchRunning: 'Ricerca in corso...',
      searchRunningDesc: 'Sto cercando su Tutti.ch, Anibis.ch e altri marketplace...',
      firstSearchNote: 'Prima ricerca: gli annunci vengono caricati direttamente dai marketplace.',
      filters: 'Filtri',
      minPrice: 'Prezzo min.',
      maxPrice: 'Prezzo max.',
      marketplaces: 'Marketplace',
      category: 'Categoria',
      allCategories: 'Tutte le categorie',
      sortBy: 'Ordina per',
      relevance: 'Rilevanza',
      priceLow: 'Prezzo crescente',
      priceHigh: 'Prezzo decrescente', endingSoonest: 'In chiusura',
      newest: 'Più recente',
      dealScore: 'Miglior offerta',
      applyFilters: 'Applica',
      resetFilters: 'Resetta',
      viewListing: 'Vedi annuncio',
      saveSearch: 'Salva ricerca',
      searchSaved: 'Ricerca salvata',
      ago: 'fa',
      minute: 'minuto',
      minutes: 'minuti',
      hour: 'ora',
      hours: 'ore',
      day: 'giorno',
      days: 'giorni',
      new: 'NUOVO',
      dealsTitle: 'Migliori Offerte in Svizzera',
      dealsSubtitle: 'Annunci sotto il valore di mercato',
      estimatedValue: 'Valore stimato',
      priceWindowLong: 'Prezzo medio su {{months}} mesi: stima meno sicura',
      priceWindowSeason: "Include la stessa stagione dell'anno scorso: stima meno sicura",
      dealDiscount: 'sotto il valore di mercato',
      newestTitle: 'Annunci più recenti',
      newestSubtitle: 'Appena pubblicati',
      last5min: 'Ultimi 5 min.',
      last15min: 'Ultimi 15 min.',
      last1h: 'Ultima ora',
      last24h: 'Ultime 24 ore',
      last7d: 'Ultimi 7 giorni',
      allTime: 'Tutti',
      savedTitle: 'Ricerche salvate',
      savedSubtitle: 'Gestisci le tue ricerche e avvisi',
      savedLoginRequired: 'Accedi per vedere e gestire i tuoi annunci salvati, ricerche e avvisi.',
      loginRequired: 'Accedi per salvare gli annunci',
      noSaved: 'Nessuna ricerca salvata',
      createAlert: 'Crea avviso',
      deleteSearch: 'Elimina',
      recentSearches: 'Cercato di recente',
      alertsSection: 'Avvisi', savedSearchesSection: 'Ricerche salvate',
      alertKeywordLabel: 'Parola di ricerca *', alertEmailOptional: 'E-mail (opzionale, per notifiche)',
      alertMinPriceLabel: 'Prezzo minimo CHF (opzionale)',
      alertMaxPriceLabel: 'Prezzo massimo CHF (opzionale)',
      alertPriceRange: 'Prezzo',
      noAlerts: 'Nessun avviso. Crea un avviso per nuovi annunci.',
      alertActive: 'Attivo', cancel: 'Annulla', searchBtn: 'Cerca',
      deleted: 'Eliminato', alertDeleted: 'Avviso eliminato', alertCreated: 'Avviso creato',
      savedListingsSection: 'Annunci salvati', noSavedListings: 'Nessun annuncio salvato',
      priceWatchesSection: 'Avvisi prezzo',
      noPriceWatches: 'Nessun avviso prezzo attivo.',
      noPriceWatchesHint: 'Apri un annuncio e usa "Avvisami se scende" per crearne uno.',
      currentPrice: 'Attuale',
      targetPrice: 'Soglia',
      priceTargetReached: 'Prezzo raggiunto',
      notified: 'Notificato',
      watching: 'In monitoraggio',
      soldLabel: 'Venduto',
      editThreshold: 'Modifica soglia',
      editThresholdPrompt: 'Nuovo prezzo soglia (CHF):',
      thresholdUpdated: 'Soglia aggiornata',
      invalidPrice: 'Prezzo non valido',
      digestModeInstant: 'Istantaneo',
      digestModeDaily: 'Riepilogo giornaliero (ore 19:00)',
      digestModeLabel: 'Notifica',
      digestModeUpdated: 'Modalità notifica aggiornata',
      digestDailyDesc: 'Una email al giorno alle 19:00 con tutti i nuovi annunci',
      digestInstantDesc: 'Notifica istantanea ogni 2 ore',
      alsoSearch: 'Cerca anche su',
      totalListings: 'annunci',
      sources: 'fonti',
      footerSlogan: 'Il motore di ricerca degli annunci in Svizzera',
      footerDisclaimer: 'ScanMarket non è affiliato ai marketplace elencati',
      footerFeedback: 'Feedback',
      footerPrivacy: 'Privacy',
      footerDataTransparency: 'I dati anonimi vengono cancellati automaticamente dopo 24 mesi',
      footerChangelog: 'Novità',
      footerHowItWorks: 'Come funziona',
      changelogTitle: 'Cosa c\'è di nuovo',
      changelogSubtitle: 'Gli ultimi miglioramenti e funzionalità di ScanMarket',
      changelogFooter: 'Pubblichiamo aggiornamenti regolarmente — torna a vedere le novità.',
      clKindFeature: 'Novità',
      clKindImprovement: 'Miglioria',
      clKindFix: 'Correzione',
      announcementLabel: 'Novità',
      announcementTitle: 'Prezzo di mercato con finestra per categoria e ricerca più precisa per misure (es. «12-24mm f2.8»)',
      appTeaserTitle: 'Stiamo lavorando a un\'applicazione per iOS e Android',
      appTeaserBody: 'Arriveranno novità a breve. Resta sintonizzato!',
      whatsNew: 'Novità',
      announcementCta: 'Scopri',
      announcementDismiss: 'Chiudi',
      cl_aiDeal_title: 'Filtro AI contro i falsi affari',
      cl_assistant_title: 'Il tuo assistente personale (Pro)',
      cl_assistant_desc: 'Chiedigli se un oggetto vale il suo prezzo: risponde con i prezzi reali di Tutti, Anibis, Ricardo, Shpock ed eBay Svizzera — e se vuoi ti scrive anche il messaggio per trattare col venditore.',
      cl_valuePhoto_title: 'Quanto vale il mio oggetto? (Pro)',
      cl_valuePhoto_desc: 'Descrivi o fotografa quello che vuoi vendere: ti diciamo a quanto si vende davvero in Svizzera. La foto non viene mai salvata.',
      cl_waitBuy_title: 'Aspetta o compra ora? (Pro)',
      cl_waitBuy_desc: 'Sullo storico dei prezzi ti diciamo se quell\'oggetto di solito cala ancora o se conviene comprarlo subito.',
      cl_autoRenew_title: 'Pro con rinnovo automatico',
      cl_autoRenew_desc: 'CHF 5.90 il primo mese, poi CHF 5.40 al mese: non devi più riattivarlo a mano e disdici quando vuoi con un click.',
      cl_priceAccuracy_title: 'Prezzi e avvisi più precisi',
      cl_priceAccuracy_desc: 'Abbiamo eliminato una causa di falsi ribassi e ora gli avvisi di prezzo arrivano solo per gli annunci su cui li hai attivati tu.',
      cl_photoSearch_title: 'Cerca con una foto',
      cl_photoSearch_desc: 'Novità: icona fotocamera nella barra di ricerca. Fotografa un oggetto o carica un\'immagine — riconosciamo prodotto, marca e modello e ti mostriamo gli annunci corrispondenti su tutti i marketplace. La foto viene solo analizzata e subito scartata, mai salvata.',
      cl_typoFix_title: 'Gli errori di battitura si correggono da soli',
      cl_typoFix_desc: 'Scrivendo «plastation 5» o «iphon 15» vedi subito i risultati giusti, con l\'indicazione del termine effettivamente cercato. Prima c\'era solo un suggerimento da cliccare.',
      cl_synonyms_title: 'Velo, bici, Fahrrad — una ricerca, tutte le lingue',
      cl_synonyms_desc: 'Circa 60 nuovi gruppi di sinonimi con veri elvetismi: velo, Töff, Töffli, Natel, trottinett, Finken… Cerca nella tua lingua e trovi gli annunci in tutte e quattro le lingue, plurali e accenti compresi.',
      cl_relevance_title: 'Risultati di ricerca molto più precisi',
      cl_relevance_desc: 'Prima «PlayStation 5» restituiva anche appartamenti da 5.5 locali o scarpe n. 45. Ora tutte le parole devono corrispondere, i numeri appartengono al modello («iPhone 5» ≠ «iPhone 15») e il titolo conta più della descrizione.',
      cl_contentFilter_title: 'Niente più annunci erotici o di servizi',
      cl_contentFilter_desc: 'Annunci di massaggi erotici e accompagnamento, oltre a interi settori di servizi e offerte di lavoro dei marketplace, vengono filtrati — i prodotti come pistole massaggianti o poltrone massaggianti restano ovviamente disponibili.',
      cl_dealsDedupe_title: 'Migliori offerte senza doppioni',
      cl_dealsDedupe_desc: 'Gli annunci quasi identici dello stesso venditore compaiono una volta sola, così come quelli pubblicati contemporaneamente su Tutti e Anibis. Più varietà in ogni pagina.',
      cl_moreListings_title: 'Molti più annunci da Tutti e Anibis',
      cl_moreListings_desc: 'Dopo un cambiamento tecnico leggiamo circa 20 volte più annunci per giro da Tutti.ch e Anibis.ch — le nuove offerte arrivano più in fretta e più complete.',
      cl_infiniteScroll_title: 'Scroll infinito sulle pagine annunci',
      cl_infiniteScroll_desc: 'Su Migliori Offerte, Ultimi Annunci, Aste e Risultati di ricerca gli annunci si caricano automaticamente mentre scorri — niente più click su pagina 2, 3, 4…',
      cl_dealsNewestFix_title: 'Migliori Offerte e Home: ordinamento e mix corretti',
      cl_dealsNewestFix_desc: 'La pagina Migliori Offerte ora si apre con gli annunci più recenti per default. Sezione "Ultimi annunci" della home: bilanciata fra Tutti, Anibis, Ricardo, Shpock e eBay invece di mostrare un solo marketplace.',
      cl_howItWorks_title: 'Nuova pagina "Come funziona"',
      cl_howItWorks_desc: 'Una pagina semplice che spiega in 4 passi come ScanMarket aggrega gli annunci dei 5 marketplace svizzeri. Utile da condividere con chi non ci ha mai provato.',
      cl_seoSsr_title: 'SEO vera — annunci ora visibili su Google',
      cl_seoSsr_desc: 'ScanMarket appare nei risultati Google con i titoli e le immagini giuste. Anche le anteprime su WhatsApp e Telegram mostrano la foto del prodotto e il prezzo quando condividi un link.',
      cl_categoryPages_title: 'Pagine categoria dedicate',
      cl_categoryPages_desc: 'Ogni categoria ha ora la sua pagina (es. /c/furniture) con tutti gli annunci, statistiche e categorie correlate — clicca una categoria in home per accedervi direttamente.',
      cl_subcategories_title: 'Filtro sotto-categorie',
      cl_subcategories_desc: 'Su ogni pagina categoria trovi velocemente le sotto-categorie (es. dentro Mobili: divani, sedie, tavoli). Solo le sotto-cat con almeno 15 annunci sono mostrate — meno rumore.',
      cl_newCats_title: '7 nuove categorie',
      cl_newCats_desc: 'Immobili, Bambini & Neonati, Animali, Antiquariato & Arte, Collezionismo, Biglietti & Buoni, Barche — prima nascoste sotto "Altro", ora cercabili a parte.',
      cl_sharePreview_title: 'Anteprime link migliori',
      cl_sharePreview_desc: 'Quando condividi un link annuncio su WhatsApp, Telegram, Twitter o Facebook, ora vedi la vera foto prodotto e il prezzo — non più solo il logo ScanMarket.',
      cl_anibisCats_title: 'Anibis: categorizzazione corretta',
      cl_anibisCats_desc: 'Gli annunci Anibis a volte finivano nella categoria sbagliata (es. sotto "Altro" invece di "Mobili"). Ora corretto — grazie a chi ce l\'ha segnalato.',
      cl_aiDeal_desc: 'La nostra AI verifica ogni top deal e identifica difetti nascosti, titoli ingannevoli o contraffazioni. Vedrai solo veri affari, con una breve spiegazione del perché sono convenienti.',
      cl_privacy_title: 'Trasparenza & Privacy (LPD/GDPR)',
      cl_privacy_desc: 'Preferenze cookie completamente personalizzabili. Gli IP sono sempre anonimizzati. I dati anonimi vengono cancellati dopo 24 mesi.',
      cl_nightMode_title: 'Aggiornamento più veloce degli annunci',
      cl_nightMode_desc: 'Abbiamo ottimizzato lo scraping dei marketplace per risultati più veloci la mattina, quando cerchi nuovi affari.',
      cl_proUpsell_title: 'Suggerimenti Pro più intelligenti',
      cl_proUpsell_desc: 'Le funzionalità Pro vengono mostrate esattamente quando servono — basta banner inutili.',
      cl_homepage_title: 'Nuova homepage con più offerte',
      cl_homepage_desc: 'Le Migliori Offerte ora sono in alto a tutta larghezza con 16 annunci — trova prima quello che cerchi.',
      cl_ghostAuction_title: 'Aste scadute nascoste',
      cl_ghostAuction_desc: 'Bug risolto: alcune aste Ricardo rimanevano visibili dopo la scadenza. Ora vengono rimosse automaticamente.',
      cookieTitle: 'Rispettiamo la tua privacy',
      cookieDesc: 'Usiamo cookie analitici anonimi per migliorare ScanMarket. Non condividiamo mai i tuoi dati.',
      cookiePrivacyLink: 'Leggi l\'informativa privacy',
      cookieLegalNote: 'Conforme LPD e GDPR — gli IP sono sempre anonimizzati.',
      cookieAcceptBtn: 'Accetta tutti',
      cookieRejectBtn: 'Rifiuta',
      cookieSettingsLink: 'Preferenze cookie',
      cookieCurrentStatus: 'Stato attuale',
      privacyTitle: 'Informativa Privacy',
      privacyLastUpdated: 'Ultimo aggiornamento',
      privacyDate: 'aprile',
      privacyIntro: 'ScanMarket.ch rispetta la tua privacy ed è conforme alla Legge federale svizzera sulla protezione dei dati (LPD) e al GDPR europeo. Questa informativa descrive quali dati raccogliamo e perché.',
      privacyDataWeCollect: 'Dati che raccogliamo',
      privacyDataPageviews: 'Visualizzazioni di pagina anonimizzate (IP mascherato a /24, nessun fingerprint browser senza consenso).',
      privacyDataAccount: 'Informazioni account alla registrazione (email, nome) — solo con il tuo consenso.',
      privacyDataSaved: 'I tuoi annunci salvati e preferenze di notifica, solo se sei loggato.',
      privacyDataPayments: 'Le informazioni di pagamento sono gestite esclusivamente da Stripe — non memorizziamo dati della carta.',
      privacyCookiesTitle: 'Cookie',
      privacyCookiesDesc: 'Usiamo un numero minimo di cookie. I cookie analitici sono attivati solo se accetti.',
      privacyColName: 'Nome',
      privacyColPurpose: 'Scopo',
      privacyColRetention: 'Ritenzione',
      privacyCookieSession: 'ID sessione per navigazione anonima',
      privacyCookieConsent: 'Memorizza la tua scelta sui cookie',
      privacyCookieLang: 'Le tue preferenze linguistiche',
      privacyCookiePosthog: 'Analitiche anonime (solo dopo consenso)',
      privacyRetSession: 'Sessione',
      privacyRet60m: '60 mesi',
      privacyRet12m: '12 mesi',
      privacyCookiesChange: 'Puoi modificare le tue preferenze in qualsiasi momento',
      privacyRightsTitle: 'I tuoi diritti',
      privacyRightsDesc: 'In conformità con GDPR e LPD, hai i seguenti diritti:',
      privacyRightAccess: 'Accesso ai tuoi dati personali',
      privacyRightErase: 'Cancellazione dei tuoi dati ("diritto all\'oblio")',
      privacyRightPortability: 'Portabilità dei dati',
      privacyRightObject: 'Opposizione al trattamento',
      privacyContactTitle: 'Contatto',
      privacyContactDesc: 'Per qualsiasi domanda sulla privacy scrivi a',
      privacyLegalBasis: 'Base legale: Legge federale svizzera sulla protezione dei dati (LPD), GDPR art. 6(1)(a) consenso e 6(1)(f) legittimo interesse per aggregati anonimi.',
      footerDataFrom: 'Dati da',
      condNew: 'Nuovo', condLikeNew: 'Come nuovo', condGood: 'Buono', condFair: 'Discreto', condBroken: 'Difettoso',
      description: 'Descrizione', translated: 'tradotto', original: 'Originale', translateTo: 'Traduci in',
      detailsSection: 'Dettagli', positionLabel: 'Posizione', postalCode: 'CAP', publishedAt: 'Pubblicato', detectedAt: 'rilevato',
      conditionLabel: 'Condizione', brandLabel: 'Marca', saleTypeLabel: 'Tipo vendita', categoryLabel: 'Categoria',
      priceHistory: 'Storico Prezzi', priceStable: 'Stabile', fromFirstRecord: 'dal primo rilevamento',
      minLabel: 'Min', maxLabel: 'Max', priceRecordedOn: 'Prezzo rilevato il',
      priceGraphSoon: 'Il grafico apparirà con più rilevamenti nel tempo.', priceCheckedOnOpen: 'Ogni volta che apri questo annuncio, il prezzo viene verificato.', priceHistoryCollecting: 'Storico prezzi in raccolta...', priceHistoryProTitle: 'Alert prezzo & storico — Pro', priceHistoryProDesc: 'Ricevi notifiche quando il prezzo scende o compaiono nuovi annunci. Include lo storico prezzi.', discoverPro: 'Scopri Pro', datePosted: 'Pubblicato sul sito originale', dateScraped: 'Ultima scansione di ScanMarket', aiDisclaimer: 'Analisi automatica — verifica sempre prima dell\'acquisto.', aiBadgeTitle: 'Analisi AI', aiBadgeAria: 'Spiegazione AI — tocca per vedere il testo completo',
      openOn: 'Apri su', goToListingOn: 'Vai all\'annuncio su',
      auctionPageTitle: 'Aste in Corso', auctionPageSubtitle: 'Ricardo.ch — prezzi bid aggiornati ogni 2 ore',
      allAuctionsTab: 'Tutte le Aste', premiumAuctionsTab: '🏆 Aste Premium',
      priceRangeLabel: 'Fascia prezzo', allPrices: 'Tutti', extraFilters: 'Filtri extra',
      filtersLabel: 'Filtri', applyFilters: 'Applica', resetFilters: 'Reimposta filtri',
      premiumOnly: 'Solo Premium (>CHF 500)', removePremiumFilter: 'Rimuovi filtro Premium',
      premiumAuctionsTitle: 'Aste Premium', premiumAuctionsSubtitle: 'Offerta attuale > CHF 500',
      noAuctionsPremium: 'Nessuna asta premium al momento', auctionsCount: 'aste', noAuctions: 'Nessuna asta trovata', removeFilters: 'Rimuovi filtri',
      createAlertTitle: '🔔 Crea Alert', notificationsFor: 'Notifiche per', enterAtLeastOne: 'Inserisci almeno un metodo di notifica',
      telegramChatId: 'Telegram Chat ID', telegramIdHint: 'Scrivi /start a @ScanMarketChBot per ricevere il tuo ID',
      activating: 'Creazione...', activateNotifications: '🔔 Attiva notifiche',
      stayUpdated: '🔔 Rimani aggiornato', alertBannerText: 'Vuoi ricevere una notifica quando escono nuovi', alertBannerText2: '?',
      activateFreeAlert: 'Attiva alert (Pro)',
      proTitle: 'ScanMarket Pro', proUpgradeCta: '🚀 Attiva Pro — CHF 9.90/mese', proStripNote: 'Pagamento sicuro via Stripe · Disdici quando vuoi',
      proBenefitAlerts: 'Notifiche email e Telegram', proBenefitUnlimited: 'Fino a 3 alert attivi su qualsiasi prodotto', proBenefitHistory: 'Storico prezzi e deal score',
      promote: '⭐ Promuovi',
      featuredTitle: 'Metti in evidenza il tuo annuncio',
      featuredSubtitle: 'Hai già un annuncio su Tutti.ch, Ricardo.ch, Anibis.ch o Shpock? Fallo vedere a tutti i visitatori di ScanMarket.',
      featuredHow: 'Come funziona',
      featuredStep1: 'Incolla il link del tuo annuncio esistente',
      featuredStep2: 'Verifica l\'anteprima automatica',
      featuredStep3: 'Scegli il livello (CHF 4.90 / 8.90 / 14.90) e paga — badge, posizione e homepage secondo il livello',
      featuredProNote: 'Al primo abbonamento Pro: 1 annuncio in evidenza omaggio — Base (CHF 4.90) col mensile, Standard (CHF 8.90) con l\'annuale',
      featuredUrlLabel: 'URL del tuo annuncio *',
      featuredLoadPreview: 'Carica anteprima',
      featuredSupported: 'Supportati: Tutti.ch, Anibis.ch, Ricardo.ch, Shpock, eBay.ch',
      featuredPreviewLabel: 'Anteprima annuncio:',
      featuredProduct: 'In evidenza',
      featuredBenefit1: '✅ Badge "In evidenza" su 5 pagine: Homepage, Deals, Ultimi, Aste, Risultati ricerca',
      featuredBenefit2: '✅ Sempre in cima — visibile prima di tutti gli annunci normali',
      featuredBenefit3: '✅ 10 giorni di visibilita, migliaia di potenziali acquirenti al giorno',
      featuredPayCta: '⭐ Paga e metti in evidenza',
      featuredStripeNote: 'Pagamento sicuro via Stripe',
      featuredSuccessTitle: 'Annuncio in evidenza attivato! 🎉', featuredSuccessText: 'Il tuo annuncio apparirà in cima ai risultati per 10 giorni.',
      featuredSuccessWhat: '✅ Cosa succede ora:', featuredSuccessBadge: '⭐ Il tuo annuncio ha il badge "In evidenza"', featuredSuccessTop: '🔝 Mostrato in cima nelle ricerche pertinenti', featuredSuccessHome: '👥 Visibile nella homepage di ScanMarket',
      featuredBackHome: 'Torna alla home →',
      featuredCheckingPayment: 'Verifica pagamento...', featuredWait: 'Attendere qualche secondo',
      featuredPaymentFailed: 'Pagamento non riuscito', featuredRetry: 'Riprova',
      loading: 'Caricamento...',
      error: 'Errore',
      retry: 'Riprova',
      chf: 'CHF',
      free: 'Gratis',
      recentlyViewed: 'Visto di recente', recentlyViewedNewBadge: 'nuovi',
      clearAll: 'Elimina tutto',
      confirmClearAll: 'Confermi?',
      forYou: 'Per te',
      whatIsItWorth: 'Quanto vale?',
      whatIsItWorthShort: 'Valore',
      menuGroupDiscover: 'Scopri',
      menuGroupMine: 'Il mio',
      menuGroupSettings: 'Impostazioni',
      checkingAvailability: 'Verifica disponibilità in corso...',
      listingUnavailable: 'Questo annuncio potrebbe non essere più disponibile',
      availabilityWarning: 'Non è stato possibile verificare la disponibilità — controlla sul sito originale',
      loadingPhotos: 'Caricamento foto...',
      galleryTitle: 'Foto', galleryClose: 'Chiudi', galleryPrev: 'Foto precedente', galleryNext: 'Foto successiva', galleryOpen: 'Guarda le foto a tutto schermo',
      saveListing: 'Salva',
      savedListing: 'Salvato',
      removedFromSaved: 'Rimosso dai salvati',
      listingSaved: 'Annuncio salvato!',
      limitReached: 'Limite raggiunto — passa a Pro',
      avgPriceForSimilar: 'Prezzo medio per oggetti simili',
      yearContextLabel: 'Annata',
      yearContextText: 'Questo è un {{year}}: i {{year}} stanno a CHF {{median}}, i {{latestYear}} a CHF {{latestMedian}}.',
      belowAverage: 'sotto la media',
      aboveAverage: 'sopra',
      basedOnComparables: 'Basato su {{count}} annunci simili nel database',
      priceWatchTitle: 'Avvisami se scende di prezzo',
      priceWatchNotify: 'Avvisami',
      priceWatchSet: 'Ti avviseremo quando scenderà sotto CHF {{price}}',
      invalidPrice: 'Inserisci un prezzo valido',
      priceWatchError: 'Errore nella creazione dell\'avviso',
      similarListings: 'Potrebbe interessarti anche',
      reportSent: 'Segnalazione inviata',
      reportUnavailable: 'Segnala annuncio non disponibile',
      loginToReport: 'Devi accedere per segnalare un annuncio',
      signIn: 'Accedi',
      alreadyReported: 'Hai già segnalato questo annuncio',
      thanksReport: 'Grazie per la segnalazione!',
      reportError: 'Errore durante la segnalazione',
      linkCopied: 'Link copiato!',
      copyFailed: 'Impossibile copiare il link',
      emailOptional: 'Email (opzionale)',
      scrapingBanner: 'Aggiornamento annunci in corso — nuovi risultati tra pochi secondi...',
      pushBannerTitle: 'Rimani aggiornato',
      pushBannerDesc: 'Ricevi notifiche istantanee quando troviamo occasioni eccezionali per le tue ricerche.',
      pushBannerActivate: 'Attiva notifiche',
      pushBannerActivating: 'Attivazione...',
      pushBannerDismiss: 'Non ora',
      pushSuccess: 'Notifiche attivate!',
      pushErrorGeneric: 'Impossibile attivare le notifiche',
      pushErrorDenied: 'Permessi negati dal browser. Controlla le impostazioni del sito.',
      pushErrorUnsupported: 'Il tuo browser non supporta le notifiche push',
      featuredLabel: 'In evidenza',
      loginTitle: 'Accedi',
      registerTitle: 'Crea account',
      forgotTitle: 'Password dimenticata',
      continueGoogle: 'Continua con Google',
      googleDesc: 'Nessuna password da ricordare. Accesso sicuro con il tuo account Google.',
      loginSubmitBtn: 'Accedi',
      forgotLink: 'Password dimenticata?',
      registerLink: 'Registrati →',
      namePlaceholder: 'Il tuo nome',
      passPlaceholder: 'Password (min 8 caratteri)',
      passConfirmPlaceholder: 'Conferma password',
      createAccountBtn: 'Crea account',
      haveAccount: 'Hai già un account?',
      forgotDesc: 'Inserisci la tua email e ti mandiamo un link per reimpostare la password.',
      resetSubmitBtn: 'Invia email di reset',
      backToLogin: '← Torna al login',
      passwordMismatch: 'Le password non coincidono',
      passwordTooShort: 'Password minimo 8 caratteri',
      welcomeUser: 'Benvenuto, {{name}}!',
      welcomeBack: 'Bentornato, {{name}}!',
      welcomeNew: 'Benvenuto su ScanMarket, {{name}}!',
      resetSent: 'Email inviata a {{email}} — controlla la casella',
      googleError: 'Login Google annullato o fallito',
      connectionError: 'Errore di connessione. Riprova.',
      nudgeTitle: 'Tieni traccia delle offerte',
      nudgeDesc: 'Salva annunci e ricevi avvisi sulle migliori offerte.',
      nudgeDismiss: 'Dopo',
      reportBtn: 'Segnala',
      reportBtnDone: 'Segnalato',
      unavailableShort: 'Non più disponibile',
      radarOff: 'Radar disattivato per "{{keyword}}"',
      radarOn: 'Radar attivo per "{{keyword}}" — riceverai notifiche per annunci simili',
      limitSavedPro: 'Limite raggiunto — passa a Pro per annunci illimitati',
      limitAlertPro: 'Gli alert sono una feature Pro — passa a Pro per ricevere notifiche email sui tuoi affari preferiti',
      proUpsellAlertTitle: 'Non perdere più un affare',
      proUpsellAlertDesc: 'Con Pro ricevi alert email automatici appena un annuncio corrisponde alle tue parole chiave.',
      proUpsellSavedTitle: 'Salva tutti gli annunci che vuoi',
      proUpsellSavedDesc: 'Con Pro non hai limiti di salvataggio: ritrovi sempre i tuoi preferiti.',
      proUpsellCompareTitle: 'Confronta gli annunci fianco a fianco',
      proUpsellCompareDesc: 'Con Pro metti più annunci uno accanto all\'altro e scegli il migliore.',
      proUpsellAnalyticsTitle: 'Analisi prezzo dettagliate',
      proUpsellAnalyticsDesc: 'Con Pro vedi storico prezzi, mediana e statistiche di mercato per ogni ricerca.',
      proUpsellPriceHistoryTitle: 'Storico prezzi nel dettaglio',
      proUpsellPriceHistoryDesc: 'Con Pro vedi come è variato il prezzo di ogni annuncio nel tempo.',
      proUpsellBenefitUnlimited: 'Salvataggi illimitati',
      proUpsellBenefitAlerts: 'Alert email per nuovi annunci e ribassi di prezzo',
      proUpsellBenefitPriceHistory: 'Storico prezzi e trend di mercato',
      proUpsellBenefitNoAds: 'Senza pubblicità, supporto prioritario',
      proUpsellForYou: '↑ per te',
      proUpsellCta: 'Scopri Pro',
      proUpsellLater: 'Non ora',
      compareSelected: 'selezionati',
      compareReady: 'Pronto al confronto',
      compareNeedMore: 'Seleziona 2+ annunci',
      compareCta: 'Confronta',
      compareClear: 'Svuota selezione',
      compareTitle: 'Confronto annunci',
      compareField: 'Campo',
      compareBestPrice: '(prezzo migliore)',
      compareEnableHint: 'Seleziona annunci da confrontare',
      compareModeOn: 'Fine confronto',
      compareModeOff: 'Confronta (Pro)',
      openedOnSource: 'Aperto su {{source}}',
      scanmarketHere: 'ScanMarket resta qui per te',
      fromYou: 'da te',
      verifiedDealTooltip: 'Confrontato con {{count}}+ prodotti simili a prezzi omogenei. Alta affidabilità.',
      uncertainDealTooltip: 'I prezzi comparabili variano — verifica sul marketplace.',
      medianTooltip: 'Valore mediano da annunci simili nel database',
      dealCalcTooltip: 'Come calcoliamo il valore stimato?',
      dealCalcDesc: 'Confrontiamo il prezzo con annunci simili per titolo e categoria.',
      estValueLabel: 'Valore stimato',
      verifyAvailability: 'Verifica disponibilità',
      aboutDaysAgo: '~{{days}}gg',
      loginToReportToast: 'Devi accedere per segnalare un annuncio',
      reportAlreadyDone: 'Hai già segnalato questo annuncio',
      reportThanks: 'Grazie per la segnalazione!',
      reportErrorToast: 'Errore durante la segnalazione',
      close: 'Chiudi',
    }
  },
  en: {
    translation: {
      home: 'Search',
      deals: 'Best Deals',
      newest: 'Newest',
      saved: 'Saved',
      auctions: 'Auctions',
      proActiveMenu: 'Pro active',
      proUpgradeMenu: 'Upgrade to Pro',

      login: 'Sign in',
      signupOrLogin: 'Sign up / Sign in',
      logout: 'Sign out',
      heroTitle: 'Find the best deals\nin Switzerland',
      heroSubtitle: 'ScanMarket is an aggregator that lets you search across Ricardo, Tutti, Anibis, Shpock and eBay Switzerland at the same time.',
      heroTagline: 'Find the deal before anyone else.',
      liveUpdateBadge: 'Live · listings updated in real-time',
      headerLiveText: 'live',
      heroSearchBtn: 'Search',
      listingsCount: 'listings',
      apiDownMsg: 'The service is temporarily unavailable. We are on it — please try again in a moment.',
      apiDownRetry: 'Try again',
      similarResultsTitle: 'Similar listings',
      similarResultsHint: 'without electric mention, for “{q}”',
      correctedNoticePrefix: 'Results for',
      correctedNoticeSuffix: 'search instead for',
      imageSearchTitle: 'Search by photo',
      imageSearchAnalyzing: 'Analysing photo…',
      imageSearchFound: 'Identified',
      imageSearchNotRecognized: 'Object not recognised — try another photo',
      imageSearchFormatError: 'Only JPG, PNG or WEBP',
      imageSearchTooLarge: 'Photo too large (max 6 MB)',
      imageSearchError: 'Photo search failed',
      photoSearchCardTitle: 'Search with a photo',
      photoSearchCardDesc: 'Snap or drop a photo — we find the item across every marketplace.',
      photoSearchCardCta: 'Choose photo',
      photoSearchCardBadge: 'New',
      copyFilterLink: 'Copy link',
      photoSearchLoginRequired: 'Sign in to search with a photo',
      shareOnWhatsapp: 'Share on WhatsApp',
      shareOnTelegram: 'Share on Telegram',
      cl_priceArchive_title: 'Market price with a window per category',
      cl_priceArchive_desc: "The discount on Best Deals is now also compared with listings already sold or expired, with a window per category: 90 days for electronics, up to 6 months for vehicles, up to 12 months for musical instruments, tools and watches, the same season last year for bikes and seasonal sports items. The window only widens when there are fewer than 20 similar listings, and then you see it in the listing.",
      cl_specSearch_title: 'More precise search for sizes and lenses',
      cl_specSearch_desc: '«Sony 12 - 24mm», «12–24 mm» or «f2.8» are now understood just like «12-24mm» and «F/2,8»: you find the lens however it is written. And search stays fast even for rare queries.',
      cl_dealsFast_title: 'Faster, cleaner Best Deals',
      cl_dealsFast_desc: 'Best Deals now open much faster and no longer show real estate, animals or used shoes: only items you can really compare with the market price.',
      cl_noReload_title: 'No more reloads when you come back',
      cl_noReload_desc: "If you open a listing on the original site while a search is running and then come back, the page no longer reloads and the search doesn't restart: it simply carries on.",
      cl_gallery_title: "Full-screen photos, just like an app",
      cl_gallery_desc: "Tap a listing photo: swipe between images, zoom with two fingers or a double tap, and drag down to close. All thumbnails are at the bottom.",
      cl_back_title: "«Back» returns to the results",
      cl_back_desc: "On mobile (back button or iPhone swipe), going back from a listing now returns to the results instead of the home page.",
      cl_centerView_title: "Listing in the centre of the screen",
      cl_centerView_desc: "On desktop a listing now opens in the centre, in a bigger window, instead of on the right edge.",
      cl_autoScroll_title: "More listings automatically",
      cl_autoScroll_desc: "At the bottom of the page new listings load by themselves: no more «Load more» button.",
      cl_typoCategory_title: "Typos: the right category",
      cl_typoCategory_desc: "Type «ipune» or «mercedesschwarz» and we fix the word and apply the category of the correct word (Smartphone, Cars…). And search is faster.",
      cl_yearSearch_title: "Search with a year",
      cl_yearSearch_desc: "«iMac 2019» or «Golf 2015» now also find titles with other words in between, like «iMac 27\" Retina 5K 2019».",
      cl_auctionReminder_title: "Reminder 1 hour before an auction ends (Pro)",
      cl_auctionReminder_desc: "Tap ⏰ on an auction or save it: about 1 hour before it ends you get a message on Telegram and/or by email, with photo, current bid and buy-now price. Pick the channel on the Saved page.",
      cl_ricardoPrices_title: "Ricardo auctions: prices fixed",
      cl_ricardoPrices_desc: "Some Ricardo auctions showed the price of a similar listing. Now the current bid and buy-now price are read only from the auction itself.",
      cl_shareOne_title: "One single «Share» button",
      cl_shareOne_desc: "WhatsApp, Telegram and Copy link now live in one «Share» button: more room above the results.",
      cl_compactResults_title: "More compact results on mobile",
      cl_compactResults_desc: "Less space before the first listing: categories and related searches in one row, all buttons in a line, and the top bar is no longer cut off.",
      shareSearch: 'Share',
      shareMoreApps: 'More apps…',
      medianShort: 'Median',
      cl_photoWidget_title: 'Photo search front and centre',
      cl_photoWidget_desc: 'A new box under the search bar: snap or drop a photo and see matching listings straight away.',
      cl_newPricing_title: 'New Pro plans: monthly or yearly',
      cl_newPricing_desc: 'Pro at CHF 9.90 a month or CHF 99 a year (two months free). Your first subscription comes with a free featured listing. Existing subscribers keep their old price.',
      cl_telegramOneTap_title: 'Telegram alerts in one tap',
      cl_telegramOneTap_desc: 'No more Chat ID to copy: tap "Connect Telegram", hit Start in the bot and you are linked. You get the 3 best listings with photos plus a summary of the rest, without flooding your chat. Pro feature.',
      cl_alertPrice_title: 'Alerts with a max price and your filters',
      cl_alertPreview_title: 'Preview when creating an alert',
      cl_alertPreview_desc: 'While creating an alert you instantly see how many listings match today and how many arrived in the last 7 days. If nothing matches, we suggest using simpler words.',
      cl_tgVolume_title: "Telegram: choose how many deals",
      cl_tgVolume_desc: "For best deals on Telegram you now pick A few (3 at a time), Many (10) or All. Anything over the limit arrives as «+N more deals» with a link to the full list — no deal gets lost.",
      cl_tgDeals_title: "Best deals on Telegram (Pro)",
      cl_tgDeals_desc: "New bargains straight in your Telegram chat: photo, price, discount and a button to the seller. Pick categories, minimum discount and maximum price under «My alerts».",
      cl_fastAlerts_title: "Alerts every 10 minutes",
      cl_fastAlerts_desc: "Pro alerts are now checked every 10 minutes and can notify you every 30 minutes. Pro searches reload the marketplaces every 30 minutes.",
      cl_carSpecs_title: "Cars: year and mileage",
      cl_carSpecs_desc: "Car and motorbike cards show registration year and mileage. The year filter now ignores dates like «last service 2023».",
      cl_newOnTop_title: "New listings always on top",
      cl_newOnTop_desc: "If you stay on the results page, new listings appear at the top with the «new listings» notice — never at the bottom of the list again.",
      cl_autocomplete_title: 'Suggestions as you type',
      cl_autocomplete_desc: 'As you type we suggest the most popular searches and your recent searches – with the right category next to them (e.g. “iphone 13 in Smartphones”). Tap the empty field to see what is trending right now.',
      cl_instantSearch_title: 'Instant search',
      cl_instantSearch_desc: 'Results now appear almost instantly – even for words with synonyms (“sofa”, “bike”) and two-word searches. And when many people search at the same time, the site stays smooth.',
      cl_newListingsPill_title: 'New listings without interruptions',
      cl_newListingsPill_desc: 'While Vulpi scans the marketplaces for new listings, your list stays put. When he finds something, “X new listings” appears at the top: one tap shows them, highlighted.',
      cl_alertSuggest_title: 'Tip for glued words',
      cl_alertSuggest_desc: 'If you type “iPhone 12mini” or “golf7”, one tap gives you the right version (“12 mini”, “golf 7”) so you don\'t miss any listing.',
      cl_smartSearch_title: 'A more forgiving search',
      cl_smartSearch_desc: 'Search now understands glued words: “golf7” gives the same results as “golf 7”. And “Apple iPhone” also finds listings that only say “iPhone”.',
      cl_preciseAlerts_title: 'More precise alerts',
      cl_preciseAlerts_desc: 'Alerts only match whole words: an alert for “Kare” no longer reports a “Schubkarre”. And an “iPhone 12mini” alert now also finds listings written “12 mini”. This applies to all existing alerts.',
      cl_vulpi_title: 'Meet Vulpi!',
      cl_vulpi_desc: 'ScanMarket has a mascot: Vulpi, a fox that sniffs out deals for you. You\'ll meet it when a search finds nothing, in your saved listings and alerts, on the Pro page and on a new error page when an address doesn\'t exist or a listing has been sold.',
      cl_newLogo_title: 'New logo',
      cl_newLogo_desc: 'The logo is now Vulpi\'s head with the Swiss-red magnifying glass, clearly visible in dark mode too. The fox is also the new icon in your browser tab and on your phone\'s home screen.',
      cl_vulpiAlerts_title: 'Alerts from Vulpi',
      cl_vulpiAlerts_desc: 'Alert emails and Telegram messages now come from Vulpi: “I sniffed out 3 new listings for you!”. Our Telegram bot has a new profile picture too.',
      cl_loginFox_title: 'The fox at sign-in',
      cl_loginFox_desc: 'When you sign in or register, Vulpi follows your mouse with its eyes, watches you type and covers its eyes while you enter your password.',
      cl_smartBar_title: 'A search bar that follows you',
      cl_smartBar_desc: 'Scroll down and the top bar disappears to leave more room for listings. Scroll up a little and it comes right back, ready for a new search.',
      cl_photoIcon_title: 'Photo search in the search bar',
      cl_photoIcon_desc: 'Searching with a photo is now a camera icon right inside the home search bar: one tap and you upload a picture.',
      cl_stickyFilters_title: 'Filters stay in view',
      cl_stickyFilters_desc: 'On desktop the filter column now stays in place while you scroll, so you can refine your search without going back to the top.',
      cl_yearValue_title: 'Value curve by year',
      cl_yearValue_desc: 'The Value page now shows a simple curve of what a model is worth year by year. And every listing shows the comparison inline, e.g. "This is a 2017: 2017 models sit at CHF 280, 2019 ones at CHF 500".',
      cl_yearFilter_title: 'Model year filter',
      cl_yearFilter_desc: 'You can now pick the model year in the search filters and only see listings that state that year. The filtered link is shareable.',
      cl_noFlatsDeals_title: 'No more flats in top deals',
      cl_noFlatsDeals_desc: 'Flats, houses and land are out of top deals and out of the price maths: no more "-54%" on a 1.5-room apartment. Real objects, like an exercise bike, stay right where they are.',
      cl_telegramMode_title: 'Telegram: you choose what arrives',
      cl_telegramMode_desc: 'In the alert form you now pick "Top deals only" or "All listings" straight away — even before linking Telegram — and you can change it on an existing alert. The message also has a new "See all N listings" button carrying your filters.',
      cl_betterMedian_title: 'More accurate average prices',
      cl_betterMedian_desc: 'The average and the typical price range now compare the same product only: no more games or accessories inside a PS5 average. Faulty listings are excluded, and when there are too few truly comparable listings we show no number instead of a wrong one.',
      cl_betterCondition_title: 'More reliable condition + Ricardo descriptions',
      cl_betterCondition_desc: 'Far fewer false "Faulty" labels: condition is detected more carefully and in every language. Ricardo listings now also show the full description.',
      cl_alertPrice_desc: 'Get notified only when a listing fits your price range — the alert also keeps the marketplace, category and canton of your search. And no new listing is lost anymore, even when 50 show up at once.',
      cl_featuredTiers_title: 'Promote your listing: 3 tiers',
      cl_featuredTiers_desc: 'Base CHF 4.90 for 3 days, Standard CHF 8.90 for 7 days with a higher position, Premium CHF 14.90 for 7 days including the homepage.',
      cl_photoLogin_title: 'Photo search needs an account',
      cl_photoLogin_desc: 'To prevent abuse, searching with a photo now requires a free account.',
      cl_shareFilters_title: 'Shareable filtered searches',
      cl_shareFilters_desc: 'Price, marketplaces and sorting now live in the address bar: copy the link, share it, and everything survives a refresh.',
      relaxedNoticePrefix: 'No exact matches for',
      relaxedNoticeSuffix: 'showing results for',
      refreshLabel: 'Refresh',
      updatedLabel: 'Updated',
      dealsFound: 'deals found',
      noListingsInPeriod: 'No listings in this period',
      marketplaceCount: 'marketplaces',
      offersCount: 'deals',
      nearbyTitle: '📍 Show offers near you',
      nearbyDesc: '— activate location to see distance from each listing',
      nearbyBtn: 'Activate',
      distance: 'Distance',
      bestDeals: 'Best Deals',
      latestListings: 'Latest Listings',
      auctionsTitle: 'Live Auctions',
      auctionsPremiumLabel: 'Premium Auctions (>CHF 500)',
      auctionsRegularLabel: 'Live Auctions',
      discoverAllDeals: 'Discover all deals',
      discoverAllListings: 'Discover all listings',
      discoverAllAuctions: 'All auctions',
      discoverAllAuctionsPremium: 'Premium auctions',
      mpTuttiDesc: 'Largest Swiss marketplace',
      mpAnibisDesc: 'Romandy and beyond',
      mpRicardoDesc: 'Auctions and fixed prices',
      mpShpockDesc: 'Digital flea market',
      mpEbayDesc: 'Auctions and direct buy',
      integrated: 'Integrated ✓',
      searchOnLabel: 'Search simultaneously on',
      trendingTitle: 'Trending now',
      suggestionPrefix: 'Did you mean', facetsLabelAll: 'Categories', facetsLabelAlso: 'Also in', countryConfirmTitle: 'Your country', countryConfirmBody: 'We\'ll show you listings from {{country}}. Is that right?', countryConfirmYes: 'Yes, continue', countryConfirmChange: 'Another country', categoryDroppedNotice: 'No results in {{cat}} – showing all categories', categoryInferredLabel: 'Category auto-applied', categoryInferredRemove: 'Remove', searchInCategory: 'Search in',
      relatedLabel: 'Related searches',
      browseCategories: 'Browse by category',
      justPosted: 'JUST POSTED',
      newArrival: 'New',
      auctionBadge: 'Auction live',
      currentBid: 'Current bid',
      bids: 'bids',
      endsIn: 'Ends in',
      buyNowLabel: 'Buy it now',
      verifiedDeal: 'Verified deal',
      uncertainDeal: 'Uncertain deal',
      priceTrend: 'Median price',
      viewOffer: '🔥 View deal',
      details: 'Details',
      open: 'Open',
      save: 'Save',
      saved2: 'Saved',
      alertBtn: 'Alert',
      searchPlaceholder: 'MacBook, iPhone, PlayStation...',
      searchButton: 'Search',
      searchTitle: 'Search Swiss second-hand deals',
      searchSubtitle: 'Tutti & Anibis in one scan',
      results: 'Results',
      resultsFor: 'results for',
      noResults: 'No results found',
      noResultsHint: 'Try different keywords or search directly on the marketplaces',
      mascotNoResultsTitle: 'Nothing yet… but I won\'t give up!',
      mascotNoResultsDesc: 'Create an alert and I\'ll message you as soon as I find it.',
      mascotCreateAlert: 'Create an alert',
      alertSuggest: 'Did you mean',
      alertSuggestUse: 'Use it',
      alertPreviewLoading: 'Counting matching listings…',
      alertPreviewCount: 'Today I find {{count}} matching listings',
      alertPreviewRecent: '{{count}} in the last 7 days',
      alertPreviewNone: 'No listing matches right now: try simpler words.',
      mascotSavedEmpty: 'All quiet here… save a listing to wake me up!',
      mascotAlertsEmpty: 'No alerts yet. Create one and I\'ll message you as soon as something new shows up!',
      notFoundTitle: 'Oops… I can\'t find this page!',
      notFoundDesc: 'I sniffed everywhere, but this address doesn\'t exist. Shall we start again from the home page?',
      listingGoneTitle: 'This listing is gone!',
      listingGoneDesc: 'It was probably sold or removed. Don\'t worry: I\'ll help you find a similar one.',
      goHomeBtn: 'Back to home',
      searchRunning: 'Searching...',
      searchRunningDesc: 'Loading listings live from Tutti.ch, Anibis.ch and other marketplaces...',
      firstSearchNote: 'First search: listings are loaded directly from the marketplaces.',
      filters: 'Filters',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      marketplaces: 'Marketplaces',
      category: 'Category',
      allCategories: 'All categories',
      sortBy: 'Sort by',
      relevance: 'Relevance',
      priceLow: 'Price: low to high',
      priceHigh: 'Price: high to low', endingSoonest: 'Ending soonest',
      newest: 'Newest',
      dealScore: 'Best deal',
      applyFilters: 'Apply',
      resetFilters: 'Reset',
      viewListing: 'View listing',
      saveSearch: 'Save search',
      searchSaved: 'Search saved',
      ago: 'ago',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      new: 'NEW',
      dealsTitle: 'Best Deals in Switzerland',
      dealsSubtitle: 'Underpriced listings vs. estimated market value',
      estimatedValue: 'Est. value',
      priceWindowLong: 'Average over {{months}} months: less certain estimate',
      priceWindowSeason: 'Incl. same season last year: less certain estimate',
      dealDiscount: 'below market',
      newestTitle: 'Newest Listings',
      newestSubtitle: 'Freshly posted listings',
      last5min: 'Last 5 min',
      last15min: 'Last 15 min',
      last1h: 'Last hour',
      last24h: 'Last 24h',
      last7d: 'Last 7 days',
      allTime: 'All',
      savedTitle: 'Saved Searches',
      savedSubtitle: 'Manage your searches and alerts',
      savedLoginRequired: 'Sign in to view and manage your saved listings, searches and alerts.',
      loginRequired: 'Sign in to save listings',
      noSaved: 'No saved searches yet',
      createAlert: 'Create alert',
      deleteSearch: 'Delete',
      recentSearches: 'Recently searched',
      alertsSection: 'Alerts', savedSearchesSection: 'Saved Searches',
      alertKeywordLabel: 'Search term *', alertEmailOptional: 'Email (optional, for notifications)',
      alertMinPriceLabel: 'Min price CHF (optional)',
      alertMaxPriceLabel: 'Max price CHF (optional)',
      alertPriceRange: 'Price',
      noAlerts: 'No alerts yet. Create an alert for new listings.',
      alertActive: 'Active', cancel: 'Cancel', searchBtn: 'Search',
      deleted: 'Deleted', alertDeleted: 'Alert deleted', alertCreated: 'Alert created',
      savedListingsSection: 'Saved Listings', noSavedListings: 'No saved listings yet',
      priceWatchesSection: 'Price Watches',
      noPriceWatches: 'No active price watches.',
      noPriceWatchesHint: 'Open a listing and tap "Notify me on price drop" to create one.',
      currentPrice: 'Current',
      targetPrice: 'Target',
      priceTargetReached: 'Target reached',
      notified: 'Notified',
      watching: 'Watching',
      soldLabel: 'Sold',
      editThreshold: 'Edit threshold',
      editThresholdPrompt: 'New threshold price (CHF):',
      thresholdUpdated: 'Threshold updated',
      invalidPrice: 'Invalid price',
      digestModeInstant: 'Instant',
      digestModeDaily: 'Daily digest (7:00 PM)',
      digestModeLabel: 'Notification',
      digestModeUpdated: 'Notification mode updated',
      digestDailyDesc: 'One email per day at 7:00 PM with all new listings',
      digestInstantDesc: 'Instant notification every 2 hours',
      alsoSearch: 'Also search on',
      totalListings: 'listings',
      sources: 'sources',
      footerSlogan: 'The search engine for classifieds in Switzerland',
      footerDisclaimer: 'ScanMarket is not affiliated with the listed marketplaces',
      footerFeedback: 'Feedback',
      footerPrivacy: 'Privacy',
      footerDataTransparency: 'Anonymous data is automatically deleted after 24 months',
      footerChangelog: 'What\'s new',
      footerHowItWorks: 'How it works',
      changelogTitle: 'What\'s new',
      changelogSubtitle: 'Latest improvements and features on ScanMarket',
      changelogFooter: 'We publish updates regularly — check back for more news.',
      clKindFeature: 'New',
      clKindImprovement: 'Improvement',
      clKindFix: 'Fix',
      announcementLabel: 'New',
      announcementTitle: 'Market price with a window per category and more precise search for sizes (e.g. «12-24mm f2.8»)',
      appTeaserTitle: 'We are building an app for iOS and Android',
      appTeaserBody: 'News coming soon. Stay tuned!',
      whatsNew: "What's new",
      announcementCta: 'Discover',
      announcementDismiss: 'Dismiss',
      cl_aiDeal_title: 'AI filter against fake deals',
      cl_assistant_title: 'Your personal assistant (Pro)',
      cl_assistant_desc: 'Ask it whether an item is worth its price: it answers with the real prices from Tutti, Anibis, Ricardo, Shpock and eBay Switzerland — and it even writes your negotiation message.',
      cl_valuePhoto_title: 'What is my item worth? (Pro)',
      cl_valuePhoto_desc: 'Describe or photograph what you want to sell: we tell you what it actually sells for in Switzerland. The photo is never stored.',
      cl_waitBuy_title: 'Wait or buy now? (Pro)',
      cl_waitBuy_desc: 'Using our price history we tell you whether that item usually keeps dropping or whether you should buy right away.',
      cl_autoRenew_title: 'Pro with auto-renewal',
      cl_autoRenew_desc: 'CHF 5.90 for the first month, then CHF 5.40 a month: no more manual reactivation, cancel anytime with one click.',
      cl_priceAccuracy_title: 'More accurate prices and alerts',
      cl_priceAccuracy_desc: 'We fixed a cause of false price drops, and price alerts now only arrive for listings where you switched them on yourself.',
      cl_photoSearch_title: 'Search with a photo',
      cl_photoSearch_desc: 'New: camera icon in the search bar. Snap an item or upload an image — we identify the product, brand and model and show you matching listings across every marketplace. The photo is only analysed and immediately discarded, never stored.',
      cl_typoFix_title: 'Typos are now fixed automatically',
      cl_typoFix_desc: 'Type «plastation 5» or «iphon 15» and you go straight to the right results, with a note showing what was actually searched. Before, there was only a suggestion to click.',
      cl_synonyms_title: 'Velo, bici, Fahrrad — one search, every language',
      cl_synonyms_desc: 'Around 60 new synonym groups with real Swiss words: Velo, Töff, Töffli, Natel, Trottinett, Finken… Search in your language and find listings in all four national languages, plurals and accents included.',
      cl_relevance_title: 'Much sharper search results',
      cl_relevance_desc: '«PlayStation 5» used to return 5.5-room flats and size 45 shoes too. Now every word has to match, numbers belong to the model («iPhone 5» ≠ «iPhone 15») and the title counts more than the description.',
      cl_contentFilter_title: 'No more adult or service ads',
      cl_contentFilter_desc: 'Erotic massage and escort ads, plus entire services and job sections of the marketplaces, are filtered out — products such as massage guns or massage chairs of course stay.',
      cl_dealsDedupe_title: 'Best deals without duplicates',
      cl_dealsDedupe_desc: 'Near-identical listings from the same seller now show up once, and so do listings posted on both Tutti and Anibis. More variety on every page.',
      cl_moreListings_title: 'Many more listings from Tutti and Anibis',
      cl_moreListings_desc: 'After a technical change we read around 20x more listings per run from Tutti.ch and Anibis.ch — new offers reach you faster and more completely.',
      cl_infiniteScroll_title: 'Infinite scroll on listing pages',
      cl_infiniteScroll_desc: 'On Best Deals, Newest, Auctions and Search Results, listings load automatically as you scroll — no more clicking page 2, 3, 4…',
      cl_dealsNewestFix_title: 'Best Deals and Home: proper sorting and mix',
      cl_dealsNewestFix_desc: 'The Best Deals page now opens with the most recent listings by default. The "Latest listings" section on the home is balanced across Tutti, Anibis, Ricardo, Shpock and eBay instead of showing one marketplace only.',
      cl_howItWorks_title: 'New "How it works" page',
      cl_howItWorks_desc: 'A simple page explaining in 4 steps how ScanMarket aggregates listings from the 5 Swiss marketplaces. Handy to share with people who haven\'t tried us yet.',
      cl_seoSsr_title: 'Real SEO — listings now visible on Google',
      cl_seoSsr_desc: 'ScanMarket now appears in Google results with proper titles and images. WhatsApp and Telegram link previews also show the product photo and price when you share a listing.',
      cl_categoryPages_title: 'Dedicated category pages',
      cl_categoryPages_desc: 'Each category has its own page now (e.g. /c/furniture) with all listings, stats and related categories — clicking a category on the homepage takes you straight there.',
      cl_subcategories_title: 'Subcategory filter',
      cl_subcategories_desc: 'On every category page you can quickly find sub-categories (e.g. inside Furniture: sofas, chairs, tables). Only sub-cats with at least 15 listings are shown — less noise.',
      cl_newCats_title: '7 new categories',
      cl_newCats_desc: 'Real Estate, Baby & Kids, Pets, Antiques & Art, Collectibles, Tickets & Vouchers, Boats — previously hidden under "Other", now browsable on their own.',
      cl_sharePreview_title: 'Better link previews',
      cl_sharePreview_desc: 'When you share a listing link on WhatsApp, Telegram, Twitter or Facebook, you now see the actual product photo and price — no more just the ScanMarket logo.',
      cl_anibisCats_title: 'Anibis: correct categorization',
      cl_anibisCats_desc: 'Anibis listings sometimes ended up in the wrong category (e.g. under "Other" instead of "Furniture"). Now fixed — thanks to everyone who reported it.',
      cl_aiDeal_desc: 'Our AI verifies every top deal and detects hidden defects, misleading titles or counterfeits. You only see real bargains, with a short explanation of why they\'re good.',
      cl_privacy_title: 'Transparency & Privacy (LPD/GDPR)',
      cl_privacy_desc: 'Fully customisable cookie preferences. IPs are always anonymised. Anonymous data is deleted after 24 months.',
      cl_nightMode_title: 'Faster listing updates',
      cl_nightMode_desc: 'We optimised the scraping of marketplaces for faster results in the morning, when you look for new bargains.',
      cl_proUpsell_title: 'Smarter Pro suggestions',
      cl_proUpsell_desc: 'Pro features show up exactly when you need them — no more useless banners.',
      cl_homepage_title: 'New homepage with more deals',
      cl_homepage_desc: 'Best Deals are now on top full-width with 16 listings — find what you want faster.',
      cl_ghostAuction_title: 'Expired auctions hidden',
      cl_ghostAuction_desc: 'Bug fixed: some Ricardo auctions remained visible after expiring. They\'re now removed automatically.',
      cookieTitle: 'We respect your privacy',
      cookieDesc: 'We use anonymous analytics cookies to improve ScanMarket. We never share your data.',
      cookiePrivacyLink: 'Read the privacy policy',
      cookieLegalNote: 'LPD & GDPR compliant — IP addresses are always anonymized.',
      cookieAcceptBtn: 'Accept all',
      cookieRejectBtn: 'Reject',
      cookieSettingsLink: 'Cookie preferences',
      cookieCurrentStatus: 'Current status',
      privacyTitle: 'Privacy Policy',
      privacyLastUpdated: 'Last updated',
      privacyDate: 'April',
      privacyIntro: 'ScanMarket.ch respects your privacy and complies with the Swiss Federal Act on Data Protection (FADP/LPD) and the EU GDPR. This policy describes what data we collect and why.',
      privacyDataWeCollect: 'Data we collect',
      privacyDataPageviews: 'Anonymised pageviews (IP masked to /24, no browser fingerprint without consent).',
      privacyDataAccount: 'Account information on registration (email, name) — only with your consent.',
      privacyDataSaved: 'Your saved listings and notification preferences, only when logged in.',
      privacyDataPayments: 'Payment information is managed exclusively by Stripe — we never store card data.',
      privacyCookiesTitle: 'Cookies',
      privacyCookiesDesc: 'We use a minimal set of cookies. Analytics cookies are enabled only if you accept.',
      privacyColName: 'Name',
      privacyColPurpose: 'Purpose',
      privacyColRetention: 'Retention',
      privacyCookieSession: 'Session ID for anonymous browsing',
      privacyCookieConsent: 'Stores your cookie choice',
      privacyCookieLang: 'Your language preference',
      privacyCookiePosthog: 'Anonymous analytics (only after consent)',
      privacyRetSession: 'Session',
      privacyRet60m: '60 months',
      privacyRet12m: '12 months',
      privacyCookiesChange: 'You can change your preferences at any time',
      privacyRightsTitle: 'Your rights',
      privacyRightsDesc: 'Under GDPR and LPD, you have the following rights:',
      privacyRightAccess: 'Access to your personal data',
      privacyRightErase: 'Erasure of your data ("right to be forgotten")',
      privacyRightPortability: 'Data portability',
      privacyRightObject: 'Object to processing',
      privacyContactTitle: 'Contact',
      privacyContactDesc: 'For any privacy-related question write to',
      privacyLegalBasis: 'Legal basis: Swiss Federal Act on Data Protection (LPD), GDPR art. 6(1)(a) consent and 6(1)(f) legitimate interest for anonymous aggregates.',
      footerDataFrom: 'Data from',
      condNew: 'New', condLikeNew: 'Like new', condGood: 'Good', condFair: 'Fair', condBroken: 'Broken',
      description: 'Description', translated: 'translated', original: 'Original', translateTo: 'Translate to',
      detailsSection: 'Details', positionLabel: 'Location', postalCode: 'Postal code', publishedAt: 'Posted', detectedAt: 'detected on',
      conditionLabel: 'Condition', brandLabel: 'Brand', saleTypeLabel: 'Sale type', categoryLabel: 'Category',
      priceHistory: 'Price History', priceStable: 'Stable', fromFirstRecord: 'from first record',
      minLabel: 'Min', maxLabel: 'Max', priceRecordedOn: 'Price recorded on',
      priceGraphSoon: 'Chart will appear with more records over time.', priceCheckedOnOpen: 'Price is verified each time you open this listing.', priceHistoryCollecting: 'Collecting price history...', priceHistoryProTitle: 'Price alerts & history — Pro', priceHistoryProDesc: 'Get notified on price drops and new listings. Price history included.', discoverPro: 'Discover Pro', datePosted: 'Published on the original site', dateScraped: 'Last scanned by ScanMarket', aiDisclaimer: 'Automated analysis — always verify before buying.', aiBadgeTitle: 'AI Analysis', aiBadgeAria: 'AI explanation — tap to see the full text',
      openOn: 'Open on', goToListingOn: 'Go to listing on',
      auctionPageTitle: 'Live Auctions', auctionPageSubtitle: 'Ricardo.ch — bid prices updated every 2 hours',
      allAuctionsTab: 'All Auctions', premiumAuctionsTab: '🏆 Premium Auctions',
      priceRangeLabel: 'Price range', allPrices: 'All', extraFilters: 'Extra filters',
      filtersLabel: 'Filters', applyFilters: 'Apply', resetFilters: 'Reset filters',
      premiumOnly: 'Premium only (>CHF 500)', removePremiumFilter: 'Remove Premium filter',
      premiumAuctionsTitle: 'Premium Auctions', premiumAuctionsSubtitle: 'Current bid > CHF 500',
      noAuctionsPremium: 'No premium auctions right now', auctionsCount: 'auctions', noAuctions: 'No auctions found', removeFilters: 'Remove filters',
      createAlertTitle: '🔔 Create Alert', notificationsFor: 'Notifications for', enterAtLeastOne: 'Please enter at least one notification method',
      telegramChatId: 'Telegram Chat ID', telegramIdHint: 'Write /start to @ScanMarketChBot to get your ID',
      activating: 'Creating...', activateNotifications: '🔔 Activate notifications',
      stayUpdated: '🔔 Stay updated', alertBannerText: 'Want to be notified when new', alertBannerText2: 'listings appear?',
      activateFreeAlert: 'Activate Pro alert',
      proTitle: 'ScanMarket Pro', proUpgradeCta: '🚀 Activate Pro — CHF 9.90/month', proStripNote: 'Secure payment via Stripe · Cancel anytime',
      proBenefitAlerts: 'Email and Telegram notifications', proBenefitUnlimited: 'Up to 3 active alerts on any product', proBenefitHistory: 'Price history and deal score',
      promote: '⭐ Promote',
      featuredTitle: 'Promote your listing',
      featuredSubtitle: 'Already have a listing on Tutti.ch, Ricardo.ch, Anibis.ch or Shpock? Show it to all ScanMarket visitors.',
      featuredHow: 'How it works',
      featuredStep1: 'Paste the link to your existing listing',
      featuredStep2: 'Check the automatic preview',
      featuredStep3: 'Pick a tier (CHF 4.90 / 8.90 / 14.90) and pay — badge, top position and homepage depending on the tier',
      featuredProNote: 'On your first Pro subscription: 1 featured listing free — Base (CHF 4.90) monthly, Standard (CHF 8.90) yearly',
      featuredUrlLabel: 'Your listing URL *',
      featuredLoadPreview: 'Load preview',
      featuredSupported: 'Supported: Tutti.ch, Anibis.ch, Ricardo.ch, Shpock, eBay.ch',
      featuredPreviewLabel: 'Listing preview:',
      featuredProduct: 'Featured listing',
      featuredBenefit1: '✅ "Featured" badge on 5 pages: Homepage, Deals, Newest, Auctions, Search Results',
      featuredBenefit2: '✅ Always on top — visible before all regular listings',
      featuredBenefit3: '✅ 10 days visibility, thousands of potential buyers per day',
      featuredPayCta: '⭐ Pay and promote',
      featuredStripeNote: 'Secure payment via Stripe',
      featuredSuccessTitle: 'Listing featured! 🎉', featuredSuccessText: 'Your listing will appear at the top of results for 10 days.',
      featuredSuccessWhat: '✅ What happens now:', featuredSuccessBadge: '⭐ Your listing has the "Featured" badge', featuredSuccessTop: '🔝 Top position in relevant searches', featuredSuccessHome: '👥 Visible on ScanMarket homepage',
      featuredBackHome: 'Back to home →',
      featuredCheckingPayment: 'Checking payment...', featuredWait: 'Please wait a moment',
      featuredPaymentFailed: 'Payment failed', featuredRetry: 'Try again',
      loading: 'Loading...',
      error: 'Error',
      retry: 'Try again',
      chf: 'CHF',
      free: 'Free',
      recentlyViewed: 'Recently viewed', recentlyViewedNewBadge: 'new',
      clearAll: 'Clear all',
      confirmClearAll: 'Are you sure?',
      forYou: 'For you',
      whatIsItWorth: 'What\'s it worth?',
      whatIsItWorthShort: 'Value',
      menuGroupDiscover: 'Discover',
      menuGroupMine: 'My account',
      menuGroupSettings: 'Settings',
      checkingAvailability: 'Checking availability...',
      listingUnavailable: 'This listing may no longer be available',
      availabilityWarning: 'Could not verify availability — check on the original site',
      loadingPhotos: 'Loading photos...',
      galleryTitle: 'Photos', galleryClose: 'Close', galleryPrev: 'Previous photo', galleryNext: 'Next photo', galleryOpen: 'View photos full screen',
      saveListing: 'Save',
      savedListing: 'Saved',
      removedFromSaved: 'Removed from saved',
      listingSaved: 'Listing saved!',
      limitReached: 'Limit reached — upgrade to Pro',
      avgPriceForSimilar: 'Average price for similar items',
      yearContextLabel: 'Model year',
      yearContextText: 'This is a {{year}}: {{year}} models sit at CHF {{median}}, {{latestYear}} ones at CHF {{latestMedian}}.',
      belowAverage: 'below average',
      aboveAverage: 'above',
      basedOnComparables: 'Based on {{count}} similar listings in the database',
      priceWatchTitle: 'Notify me if the price drops',
      priceWatchNotify: 'Notify me',
      priceWatchSet: 'We\'ll notify you when the price drops below CHF {{price}}',
      invalidPrice: 'Please enter a valid price',
      priceWatchError: 'Error creating the price alert',
      similarListings: 'You might also like',
      reportSent: 'Report sent',
      reportUnavailable: 'Report listing as unavailable',
      loginToReport: 'Sign in to report a listing',
      signIn: 'Sign in',
      alreadyReported: 'You\'ve already reported this listing',
      thanksReport: 'Thanks for the report!',
      reportError: 'Error while reporting',
      linkCopied: 'Link copied!',
      copyFailed: 'Could not copy the link',
      emailOptional: 'Email (optional)',
      scrapingBanner: 'Updating listings — new results in a few seconds...',
      pushBannerTitle: 'Stay updated',
      pushBannerDesc: 'Get instant notifications when we find exceptional deals for your searches.',
      pushBannerActivate: 'Enable notifications',
      pushBannerActivating: 'Enabling...',
      pushBannerDismiss: 'Not now',
      pushSuccess: 'Notifications enabled!',
      pushErrorGeneric: 'Unable to enable notifications',
      pushErrorDenied: 'Permission denied by browser. Check site settings.',
      pushErrorUnsupported: 'Your browser does not support push notifications',
      featuredLabel: 'Featured',
      loginTitle: 'Sign in',
      registerTitle: 'Create account',
      forgotTitle: 'Forgot password',
      continueGoogle: 'Continue with Google',
      googleDesc: 'No password to remember. Secure access with your Google account.',
      loginSubmitBtn: 'Sign in',
      forgotLink: 'Forgot password?',
      registerLink: 'Register →',
      namePlaceholder: 'Your name',
      passPlaceholder: 'Password (min 8 characters)',
      passConfirmPlaceholder: 'Confirm password',
      createAccountBtn: 'Create account',
      haveAccount: 'Already have an account?',
      forgotDesc: 'Enter your email and we\'ll send you a link to reset your password.',
      resetSubmitBtn: 'Send reset email',
      backToLogin: '← Back to sign in',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      welcomeUser: 'Welcome, {{name}}!',
      welcomeBack: 'Welcome back, {{name}}!',
      welcomeNew: 'Welcome to ScanMarket, {{name}}!',
      resetSent: 'Email sent to {{email}} — check your inbox',
      googleError: 'Google sign-in cancelled or failed',
      connectionError: 'Connection error. Please try again.',
      nudgeTitle: 'Track the deals',
      nudgeDesc: 'Save listings and get alerts on the best deals.',
      nudgeDismiss: 'Later',
      reportBtn: 'Report',
      reportBtnDone: 'Reported',
      unavailableShort: 'No longer available',
      radarOff: 'Radar deactivated for "{{keyword}}"',
      radarOn: 'Radar active for "{{keyword}}" — you\'ll be notified about similar listings',
      limitSavedPro: 'Limit reached — upgrade to Pro for unlimited listings',
      limitAlertPro: 'Alerts are a Pro feature — upgrade to Pro to receive email notifications on your favorite deals',
      proUpsellAlertTitle: 'Never miss a deal again',
      proUpsellAlertDesc: 'With Pro you get automatic email alerts as soon as a listing matches your keywords.',
      proUpsellSavedTitle: 'Save as many listings as you want',
      proUpsellSavedDesc: 'With Pro there are no limits on saves: always find your favorites again.',
      proUpsellCompareTitle: 'Compare listings side by side',
      proUpsellCompareDesc: 'With Pro you can line up multiple listings and make the best choice.',
      proUpsellAnalyticsTitle: 'Detailed price analytics',
      proUpsellAnalyticsDesc: 'With Pro you see price history, median and market stats for every search.',
      proUpsellPriceHistoryTitle: 'Price history in detail',
      proUpsellPriceHistoryDesc: 'With Pro you see how the price of each listing evolved over time.',
      proUpsellBenefitUnlimited: 'Unlimited saved listings',
      proUpsellBenefitAlerts: 'Email alerts for new listings and price drops',
      proUpsellBenefitPriceHistory: 'Price history and market trends',
      proUpsellBenefitNoAds: 'Ad-free, priority support',
      proUpsellForYou: '↑ for you',
      proUpsellCta: 'Discover Pro',
      proUpsellLater: 'Not now',
      compareSelected: 'selected',
      compareReady: 'Ready to compare',
      compareNeedMore: 'Pick 2+ listings',
      compareCta: 'Compare',
      compareClear: 'Clear selection',
      compareTitle: 'Compare listings',
      compareField: 'Field',
      compareBestPrice: '(best price)',
      compareEnableHint: 'Select listings to compare',
      compareModeOn: 'Exit compare',
      compareModeOff: 'Compare (Pro)',
      openedOnSource: 'Opened on {{source}}',
      scanmarketHere: 'ScanMarket stays here for you',
      fromYou: 'from you',
      verifiedDealTooltip: 'Compared with {{count}}+ similar products at consistent prices. High reliability.',
      uncertainDealTooltip: 'Comparable prices vary — check on the marketplace.',
      medianTooltip: 'Median value from similar listings in the database',
      dealCalcTooltip: 'How do we estimate the value?',
      dealCalcDesc: 'We compare the price with similar listings by title and category.',
      estValueLabel: 'Estimated value',
      verifyAvailability: 'Check availability',
      aboutDaysAgo: '~{{days}}d',
      loginToReportToast: 'Sign in to report a listing',
      reportAlreadyDone: 'You\'ve already reported this listing',
      reportThanks: 'Thanks for the report!',
      reportErrorToast: 'Error while reporting',
      close: 'Close',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: ['de', 'fr', 'it', 'en'],
    defaultNS: 'translation',
    detection: {
      // Prima guarda la scelta manuale salvata, poi la lingua del browser
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'scanmarket_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
;
;
